export const TRANSLATIONS_EN = {
  CameraErrorPopup: {
    InfoErrors: {
      deviceInUse:
        "<div>Can't access to the camera.</div><div>Another app is using your camera.</div><div>Release the camera and try again.</div>",
      deviceNotFound:
        '<div>Camera not found.</div><div>Make sure a camera is connected to your computer and is working properly.</div>',
      failedToAccessTheDevice:
        '<div>An error occurred while trying to access the camera.</div><div>Please try again.</div>',
    },
    InfoGuide: {
      android:
        '<ol> <li>Go to <b>Settings</b> > <b>Apps</b> > Choose your browser (Chrome, Firefox, etc.).</li> <li>Tap <b>Permissions</b>.</li> <li>Tap <b>Camera</b> and choose <b>Allow while using the app</b> or <b>Ask every time</b>.</li> </ol>',
      chrome:
        '<ol> <li>Click the <b>settings icon</b> in the address bar.</li> <li>Select <b>"Site settings"</b>.</li> <li>Find <b>Camera</b> and choose <b>Allow</b> from the dropdown.</li> </ol>',
      default: '<ol> <li>Go to browser settings.</li> <li>Turn the camera on.</li> </ol>',
      edge: '<ol> <li>Click the <b>settings icon</b> in the address bar.</li> <li>Choose <b>Permissions</b> for this site.</li> <li>Under <b>Camera</b>, select <b>Allow</b>.</li> </ol>',
      firefox:
        '<ol> <li>Click the <b>settings icon</b> next to the URL.</li> <li>Click <b>"Permissions"</b>.</li> <li>Make sure <b>"Use the Camera"</b> is set to Allow.</li> </ol>',
      ios: '<ol> <li>Go to <b>Settings</b> > <b>Privacy & Security</b> > <b>Camera</b>.</li> <li>Toggle <b>on</b> the switch for the browser you’re using (e.g., Safari, Chrome).</li> <li>If prompted in Safari, tap <b>"Allow"</b> when asked for Camera permission.</li> </ol>',
      safari:
        '<ol> <li>Go to <b>Safari</b> > <b>Settings for This Website</b>.</li> <li>Next to <b>Camera</b>, choose <b>Allow</b>.</li> </ol>',
    },
    description: 'To start video with your tutor, allow camera access in your browser',
    resolvedBtn: 'Ok, changed it!',
    skipBtn: 'Continue without camera',
    title: 'We want to see you!',
  },
  ChooseAnotherLevel: 'Choose another level',
  CommunicationProblemModalDescription:
    'Our servers are not responding. Please try again.<br />If the problem persists, please contact us at info@eb.com',
  CommunicationProblemModalTitle: 'Oops! We had a technical problem.',
  GoogleLoginProblemDescription:
    'Your teacher needs to register you and your class before you can start. After your teacher will register your class, you will be able to start your journey with Hello!',
  GoogleLoginProblemTitle: 'Oops! We had a problem.',
  IAlreadyHaveAnAccount: 'I already have an account',
  MicrophoneInfoErrors: {
    deviceInUse:
      "<div>Can't access to the microphone.</div><div>Another app is using your microphone.</div><div>Release the microphone and try again.</div>",
    deviceNotFound:
      '<div>Microphone not found.</div><div>Make sure a microphone is connected to your computer and is working properly.</div>',
    failedToAccessTheDevice:
      '<div>An error occurred while trying to access the microphone.</div><div>Please try again.</div>',
  },
  MicrophoneInfoGuide: {
    android:
      '<ol> <li>Go to <b>Settings</b> > <b>Apps</b> > Choose your browser (Chrome, Firefox, etc.).</li> <li>Tap <b>Permissions</b>.</li> <li>Tap <b>Microphone</b> and choose <b>Allow while using the app</b> or <b>Ask every time</b>.</li> </ol>',
    chrome:
      '<ol> <li>Click the <b>settings icon</b> in the address bar.</li> <li>Select <b>"Site settings"</b>.</li> <li>Find <b>Microphone</b> and choose <b>Allow</b> from the dropdown.</li> </ol>',
    default: '<ol> <li>Go to browser settings.</li> <li>Turn the microphone on.</li> </ol>',
    edge: '<ol> <li>Click the <b>settings icon</b> in the address bar.</li> <li>Choose <b>Permissions</b> for this site.</li> <li>Under <b>Microphone</b>, select <b>Allow</b>.</li> </ol>',
    firefox:
      '<ol> <li>Click the <b>settings icon</b> next to the URL.</li> <li>Click <b>"Permissions"</b>.</li> <li>Make sure <b>"Use the Microphone"</b> is set to Allow.</li> </ol>',
    ios: '<ol> <li>Go to <b>Settings</b> > <b>Privacy & Security</b> > <b>Microphone</b>.</li> <li>Toggle <b>on</b> the switch for the browser you’re using (e.g., Safari, Chrome).</li> <li>If prompted in Safari, tap <b>"Allow"</b> when asked for microphone permission.</li> </ol>',
    safari:
      '<ol> <li>Go to <b>Safari</b> > <b>Settings for This Website</b>.</li> <li>Next to <b>Microphone</b>, choose <b>Allow</b>.</li> </ol>',
  },
  MicrophoneInfoInOrderTo:
    'For some of the activities, you will need to approve microphone use in your browser',
  MicrophoneInfoInOrderToQuiz: 'To start talking, you’ll need to allow microphone access.',
  MicrophoneInfoWeWantTo: 'We want to hear you!',
  MinasLoginProblemDescription:
    'This email address is not authorized for using "Hello Britannica". Please contact your teacher/ school admin.',
  UnauthorizedLoginProblemDescription:
    'This email address is not authorized for using "Hello Britannica". Please contact your teacher/ school admin.',
  UserNotConfirmedException:
    'Your account is not verified. Please enter the verification code sent to your email.',
  about: 'About',
  accountVerifiedCanLoginNow: 'Your account has been verified. You can log in now.',
  accountVerifiedSigningIn: 'Your account is verified. Signing you in…',
  account_settings: 'Account Settings',
  achievmentsSection: {
    feedback: 'You’ve showed some extraordinary skills!',
    weeklyAchievement: 'Achievement of the week',
  },
  active: 'Active',
  activities: 'Activities',
  addNewClass: 'Add New Class',
  addYourClasses: 'Add Your Classes',
  admin: {
    accountDetailsPage: {
      accountIdRequired: 'Account ID is required for update',
      accountNotFound: 'Account not found.',
      back: 'Back',
      editAccount: 'Edit Account',
      failedToLoad: 'Failed to load account details',
      failedToUpdate: 'Failed to update account',
      loadingAccountDetails: 'Loading account details...',
    },
    accountInfoCard: {
      accountType: 'Account Type',
      brazil: 'Brazil',
      country: 'Country',
      createSchoolHint: 'Click here to create a school and onboard users to Hello.',
      creationDate: 'Creation Date',
      customerPilot: 'Customer Pilot',
      customerProduction: 'Customer Production',
      expirationDate: 'Expiration Date',
      here: 'here',
      learningLanguage: 'Learning Language',
      licensesRemaining: 'Licenses Remaining',
      loginProvider: 'Login Provider',
      nativeLanguage: 'Native Language',
      no: 'No',
      noOfDistricts: 'No. of Districts',
      noOfSchools: 'No. of Schools',
      notSet: 'Not set',
      registeredUsers: 'Registered Users',
      signInOptions: 'Sign In Options',
      systemType: 'System Type',
      tutorActive: 'Tutor Active',
      tutorType: 'Tutor Type',
      userLimit: 'User Limit',
      yes: 'Yes',
    },
    accountsListPage: {
      createNewAccount: '+ Create New Account',
      newAccount: 'New Account',
      title: 'Accounts',
    },
    bimloaFilter: {
      choose: 'Choose',
      chooseDate: 'Choose Date',
      chooseDateRange: 'Choose Date Range',
      failedToFetchSuggestions: 'Failed to fetch suggestions',
      failedToLoadSuggestions: 'Failed to load suggestions',
      last30Days: 'Last 30 days',
      last7Days: 'Last 7 days',
      range: 'Range',
      specificDate: 'Specific date',
    },
    bulkActions: {
      changeLevel: {
        chooseLevel: {
          description:
            "Change the level of {{count}} students to a new level. <b>Changing students' level will reset their scores and progress. Any previous data will be lost.</b> Note that if students are at different levels, proceeding will set all of them to the new level.",
          hasNonActivedStudentsNote:
            'Note: non-active students will not be affected by the level change.',
          level: 'Level',
          mixedLevelsWarning:
            'ℹ️ The selected students are at different levels. Proceeding will set all of them to {{newLevel}}.',
          selectLevel: 'Select a Level',
          submitButton: 'Confirm Change',
          theNewLevel: 'the new level',
          title: "Change Students' level",
        },
        currentLevel: 'Current Level',
        failure: {
          description: 'Please try again.',
          title: 'No students could be updated.',
        },
        partialSuccesses: {
          description:
            '{{completed}} of {{total}} students have been successfully moved to {{newLevel}}. The following students could not be updated:',
        },
        report: {
          actionChangeLevel: 'Change Level',
          class: 'Class',
          fileName: 'Bulk Change Level Report',
          newLevel: 'New Level',
          previousLevel: 'Previous Level',
        },
        successes: {
          title: 'All {{count}} students have been successfully moved to {{newLevel}}.',
        },
      },
      classes: {
        classesSelected_one: '1 Class Selected',
        classesSelected_other: '{{count}} Classes Selected',
        deleteClasses_one: 'Delete Class',
        deleteClasses_other: 'Delete Classes',
      },
      common: {
        action: 'Action',
        classAndGrade: 'Class & Grade',
        failureDescription: 'Please try again later.',
        failureTitle: 'We had a problem',
        name: 'Name',
        partialSuccessTitle: '⚠️ Partial Success',
        teacher: 'Teacher',
      },
      deleteClasses: {
        apiReason: 'Bulk class deletion from school admin',
        confirm: {
          deleteAnywayButton: 'Delete Classes',
          titleWithStudents: 'Are you sure?',
          understandWithStudents:
            'I understand that these students and their progress will be permanently deleted.',
          warningEmpty:
            'Are you sure you want to delete these classes? This action cannot be undone.',
          warningWithStudents:
            "You're about to delete {{classCount}} classes containing {{studentCount}} selected students. Deleting these classes will also delete these students and will permanently remove them from the platform. They will no longer be able to log in and their progress data will be lost. Once confirmed, this action cannot be undone.",
        },
        partialSuccesses: {
          description: 'Some classes could not be deleted. See the table below.',
          statusColumn: 'Status',
          statusDeleted: 'Classes Deleted',
          statusFailed: 'Deleting failed.',
          studentsDeletedRatio: '{{deleted}}/{{total}}',
          tableStudentsDeleted: 'Students Deleted',
        },
        report: {
          actionDelete: 'Delete',
          className: 'Class Name',
          fileName: 'Bulk Delete Classes Report',
          statusFailure: 'Failure',
          statusSuccess: 'Success',
        },
        successes: {
          studentsDeletedFollowUpPlural:
            'Also, {{count}} students have been successfully deleted. Deleted students have been logged out of any active sessions and will not be able to log in again.',
          studentsDeletedFollowUpSingular:
            'Also, 1 student has been successfully deleted. The student has been logged out of any active sessions and will not be able to log in again.',
          title: 'The selected classes have been successfully deleted!',
        },
      },
      deleteStudents: {
        chooseReason: {
          confirmationCheckbox:
            'I understand that these students and their progress will be permanently deleted.',
          description:
            'You’re about to delete {{num}} selected students. Deleting these students will permanently remove them from the platform. They will no longer be able to log in and their progress data will be lost. Once confirmed, this action cannot be undone.',
          reason: 'Reason',
          subDescription: 'This helps us track why students are removed from the platform.',
          subTitle: 'Please provide a reason.',
          submitButton: 'Delete Students',
          title: 'Are you sure?',
          why: 'Why?',
        },
        partialSuccesses: {
          description:
            'Deleted students have been logged out of any active sessions and will not be able to log in again.',
        },
        report: {
          class: 'Class',
          fileName: 'Bulk Delete Students Report',
        },
        successes: {
          description:
            'Deleted students have been logged out of any active sessions and will not be able to log in again.',
          title: 'The selected students have been successfully deleted!',
        },
      },
      downloadChanges: {
        downloadButton: 'Download',
        text: 'a list of the changes',
      },
      moveStudents: {
        availableSeats: {
          description:
            'You selected {{selectedCount}} students, but only {{availableSeats}} seats are available in {{destinationClass}}.\nPlease choose a different class or select fewer students.',
          title: '⚠️ This class doesn’t have enough available seats.',
        },
        chooseDestination: {
          description:
            'Move {{num}} selected students to a new class. Student progress, login history, and scores will be preserved.',
          full: 'Full',
          selectClass: 'Select a Class',
          spotsLeft: '{{num}} spots left',
          subDescription:
            'Student progress, login history, and scores will be preserved during the move.',
          subTitle: 'Choose Destination',
          submitButton: 'Move Students',
          title: 'Move Students',
        },
        differentGrade: {
          description:
            'One or more selected students are currently assigned to a class in a different grade than the destination class.',
          moveAllButton: 'Move anyway',
          moveSameButton: 'Move without these students',
          title: '⚠️ Some students are in a different grade.',
        },
        partialSuccesses: {
          description: 'Students who could not be moved still belong to their original class. ',
        },
        report: {
          actionMove: 'Move',
          fileName: 'Bulk Move Students Report',
          moveFromClass: 'Move from Class',
          moveFromGrade: 'Move from Grade',
          moveFromTeacher: 'Move from Teacher',
          moveToClass: 'Move to Class',
          moveToGrade: 'Move to Grade',
          moveToTeacher: 'Move to Teacher',
        },
        studentsTable: {
          currentClassAndGrade: 'Current Class & Grade',
          destinationClassAndGrade: 'Destination Class & Grade',
        },
        successes: {
          description: 'Student progress, login history, and scores will be preserved.',
          title: 'The selected students have been successfully moved!',
        },
      },
    },
    changePassword: {
      changePassword: 'Change Password',
      confirmPassword: 'Confirm Password',
      currentPassword: 'Current Password',
      invalidPassword: 'Invalid password',
      newPassword: 'New Password',
      password: 'Password',
      passwordsDontMatch: 'Passwords don’t match',
      reEnterNewPassword: 'Re-Enter New Password',
      requirements: 'Requirements:',
    },
    classCodeModal: {
      copyClassCode: 'Copy Code',
      copyClassCodeDescription:
        'Copy the code and send it to your students so they can join the platform!',
      yourClassCode: 'Your Class Code:',
    },
    cognitoErrors: {
      NetworkError: 'Network error. Please check your internet connection and try again.',
      invalidUsernameOrPassword: 'Invalid email or password',
    },
    collapseSidebar: 'Collapse sidebar',
    comingSoon: 'Coming Soon',
    common: {
      back: 'Back',
      cancel: 'Cancel',
      copied: 'Copied!',
      loading: 'Loading...',
      save: 'Save',
      saving: 'Saving...',
      search: 'Search',
      tabs: {
        classes: 'Classes',
        general: 'General Details',
        students: 'Students',
        teachers: 'Teachers',
      },
      tryAgain: 'Try Again',
      tryAgainLater: 'Please try again later.',
    },
    desktopOnlyMessage:
      'To watch your school’s details, reports and dashboards, please use the desktop version.',
    dir: 'ltr',
    districtDetailsPage: {
      back: 'Back',
      editDistrict: 'Edit District',
      info: {
        country: 'Country',
        creationDate: 'Creation Date',
        email: 'Email',
        expirationDate: 'Expiration Date',
        location: 'Location',
        manager: 'Manager',
        nativeLanguage: 'Native Language',
        numSchools: 'No. of Schools',
        numSchoolsHint: 'At least one school must be linked for platform use.',
        registeredUsers: 'Registered Users',
      },
      notFound: 'District not found.',
      schoolsTable: {
        addNew: '+ Add New',
        columns: {
          contact: 'Contact',
          school: 'School',
          students: 'Students',
          teachers: 'Number of Teachers',
        },
        title: 'Schools',
      },
    },
    districtsListPage: {
      columns: {
        activeUsers: 'Active Users',
        admin: 'District Admin',
        adminEmail: 'District Admin Email',
        district: 'District',
        registeredUsers: 'Registered Users',
        status: 'Status',
      },
      filters: {
        admin: 'District Admin',
        adminEmail: 'District Admin Email',
        district: 'District',
        schools: 'Schools',
      },
      newDistricts: 'New Districts',
      title: 'Districts',
    },
    districtsTable: {
      addNew: '+ Add New District',
      columns: {
        contact: 'Contact',
        district: 'District',
        schools: 'No. of Schools',
        users: 'Users',
      },
      noResults: 'There are no Districts created in this deal.',
    },
    download: 'Download',
    downloadAndView: 'Download and View',
    dropDown: {
      placeholder: 'Choose',
    },
    dynamicForm: {
      notification: {
        classCreated: 'The class has been successfully created.',
        classEdited: 'The class has been successfully edited.',
        generalError: 'Error occurred, please try again later',
        schoolNameUpdated: 'The school’s name has been successfully edited',
        studentDeleted: 'The student has been successfully deleted.',
        teacherDeleted: 'The teacher has been successfully deleted.',
        teacherEdited: 'The teacher has been successfully edited.',
      },
      popups: {
        changeStatus: {
          cancel: 'No, Keep Current',
          confirm: 'Yes, Change',
          subTitle: 'Are you sure you want to change the status? This action cannot be undone.',
          title: 'Change Status?',
        },
        editSchoolName: {
          Subtitles: 'Enter the name of the school.',
          label: 'New Name',
          ok: 'Change Name',
          title: 'Change School Name',
        },
        newAccount: {
          cancel: 'Cancel',
          confirm: 'I Agree',
          subTitle:
            'By creating this account, you agree to our terms and conditions for account management and user data handling.',
          title: 'Terms & Conditions',
        },
        newClassMessage: {
          Subtitles:
            'Your students have been emailed instructions for resetting their password. Once your students log in, they will receive a Level Test. Based on the results, they will be placed at their appropriate level and may begin their learning journey.',
          title: 'The class has been created successfully!',
        },
        newRegion: {
          ok: 'OK',
          subTitle:
            '%region admin first and last name% has been sent an email and temporary password with login instructions to HelloHub.',
          title: '%regionName% has been successfully created.',
        },
        newTeacherMessage: {
          Subtitles:
            'Your teachers have been emailed instructions for resetting their password. Once they have done so, they may begin using Hello Britannica.',
          title: 'The teachers have been added successfully!',
        },
        saved: {
          subTitle: 'Your changes have been saved!',
          title: 'Saved!',
        },
        turnOffDeal: {
          keepOn: 'No, Keep it On',
          subTitle: 'Are you sure you want to turn off this deal? This action cannot be undone.',
          title: 'Turn Off Deal?',
          turnOff: 'Yes, Turn Off',
        },
      },
      validation: {
        email: 'Please enter a valid email address.',
        invalidFormat: 'This field contains invalid characters.',
        max: 'Maximum value is {{value}}',
        maxLength: 'Maximum length is {{length}}',
        min: 'Minimum value is {{value}}',
        minLength: 'Minimum length is {{length}}',
        required: 'This field is required',
      },
    },
    error: {
      description: 'We encountered an error while processing your request. Please try again later.',
    },
    expandSidebar: 'Expand sidebar',
    form: {
      editTeacher: 'Edit Teacher',
      email: 'Email',
      firstName: 'First Name',
      lastName: 'Last Name',
    },
    genericTable: {
      classes: {
        activeStudents: 'Active Students',
        coTeacher: 'Co-Teacher',
        grade: 'Grade',
        name: 'Class Name',
        students: 'Students',
        teacher: 'Teacher Name',
      },
      clearSearch: 'Clear Search',
      clearSelection: 'Clear Selection',
      downloadAriaLabel: 'Download',
      noRecords: 'There are no records to display.',
      noResultsForSearchQuery: 'No search results found for “{{searchQuery}}”',
      searchDescription_one: '{{count}} result found for “{{searchQuery}}”',
      searchDescription_other: '{{count}} results found for “{{searchQuery}}”',
      teachers: {
        activeStudents: 'Active Students',
        firstLogin: 'First Login',
        lastLogin: 'Last Login',
        name: 'Name',
        numClasses: 'Classes',
        numStudents: 'Students',
      },
    },
    gradeLabel: 'Grade',
    historyPage: {
      dealNameLabel: 'deal name:',
      failedToLoad: 'Failed to load history data. Please try again later.',
      filters: {
        action: 'Action',
        date: 'Date',
        dealName: 'Account Name',
        dealType: 'Account Type',
        language: 'Language',
        lms: 'LMS',
      },
      title: 'History',
    },
    instructions: 'Instructions',
    lang: 'en',
    loginPage: {
      back: 'Back',
      changePasswordForm: {
        confirmPassword: 'Confirm Password',
        description: 'Please choose your own password',
        errors: {
          confirmPasswordDontMatch: 'Passwords don’t match',
          confirmPasswordIsRequired: 'Confirm password is required',
        },
        loadingText: '',
        password: 'Password',
        passwordChangedSuccessfully: 'Password changed successfully',
        passwordPlaceholder: 'Password',
        submit: 'Done',
        titel: 'Welcome!',
      },
      forgotPasswordForm: {
        confirmPassword: 'Confirm Password',
        description: 'Please enter your details',
        email: 'Email',
        emailFieldText:
          'If the email account is valid, you will receive a verification code to continue the password reset process.',
        emailPlaceholder: 'example@email.com',
        errors: {
          confirmPasswordDontMatch: 'Passwords don’t match',
          confirmPasswordIsRequired: 'Confirm password is required',
          emailFormat: 'Invalid email',
          emailIsRequired: 'Email is required',
          verificationCodeIsRequired: 'Code is required',
          verificationCodeMinimumLength: 'The code must be 6 digits at least',
        },
        loadingText: '',
        newPassword: 'Enter New Password',
        passwordChangedSuccessfully: 'Password changed successfully',
        passwordPlaceholder: 'Your password here',
        sendEmailAgain: 'Didn’t receive the code? Send again',
        submit: 'Send',
        titel: 'Reset your password',
        verificationCode: 'Verification Code',
        verificationCodePlaceholder: '6 digits',
      },
      loginForm: {
        description: 'Please enter your details',
        errors: {
          passwordIsRequired: 'Password is required',
          usernameIsRequired: 'Email is required',
        },
        forgotPassword: 'Forgot password',
        loadingText: 'Signing you in ...',
        password: 'Password',
        submit: 'Sign in',
        titel: 'Welcome!',
        username: 'Email',
      },
      passwordRequirements:
        '<div> <div>8 characters minimum length</div> <div>Contains at least 1 number</div> <div>Contains at least 1 uppercase letter</div> <div>Contains at least 1 lowercase letter</div> <div>Contains at least 1 special character</div> </div>',
      verificationCodeForm: {
        accountVerified: 'Your account has been verified.',
        description: 'Enter Verification Code',
        errors: {
          verificationCodeIsRequired: 'Verification code is required',
          verificationCodeMinimumLength: 'The code must be 6 digits at least',
        },
        loadingText: 'Signing you in ...',
        submit: 'Sign in',
        titel: 'Welcome!',
        verificationCode: 'Verification code',
        verificationCodePlaceholder: 'Enter verification code',
      },
    },
    pageHeader: {
      edit: 'Edit',
      groupedActiveFiltersSummary: 'Filters: {{count}}',
    },
    regionsListPage: {
      welcomeMessage:
        'This platform allows you to create and manage regions for the <strong>Hello Britannica English Learning</strong> Platform. Go ahead and create your first region!',
      welcomeTitle: 'Welcome Administrator!',
    },
    schoolDetailsPage: {
      classes: {
        actions: {
          addStudent: 'Add Student',
          delete: 'Delete',
          downloadReport: 'Download Class Report',
          edit: 'Edit',
          viewClass: 'View Class',
        },
        backToClasses: 'Back to Classes',
        classDeletedSuccessfully: 'The class has been successfully deleted.',
        className: 'Class Name',
        classNotFound: 'Class not found',
        continueToUploadingStudents: 'Continue to upload students',
        copyClassCode: 'Code copied successfully',
        create: 'Create',
        deleteClassModal: {
          confirmButton: 'Delete',
          description:
            'Deleting this class will also delete <strong>{{count}}</strong> active students in the class, including their progress and history. Once confirmed, this action cannot be undone.',
          descriptionEmpty: 'You’re about to delete your class. This cannot be undone.',
          descriptionSingular:
            'Deleting this class will also delete <strong>1</strong> active student in the class, including their progress and history. Once confirmed, this action cannot be undone.',
          title: 'Are you sure?',
        },
        deleteTeacherModal: {
          areYouSure: {
            description:
              'Teacher {{teacherName}} has {{numberOfStudents}} students across {{numberOfClasses}} classes. Do you want to permanently delete all students?',
            title: 'Are you sure?',
          },
          cancel: 'Cancel',
          classesWithoutStudents: {
            line: 'Class name - <strong>{{name}}</strong>.',
            lineWithClassCode:
              'Class <strong>{{name}}</strong> /<strong>{{classCode}}</strong> will be deleted.',
            title: 'The following classes will be deleted as well:',
          },
          continue: 'Continue',
          done: {
            btn: 'Done',
            deleted0StudentsXClasses: 'Deleted {{deletedClasses}} empty classes.',
            deletedNStudentsXClasses:
              'Deleted {{deletedStudents}} students and {{deletedClasses}} classes.',
            reassignedTo1Teacher:
              '{{numberOfClasses}} Classes and all associated students have been reassigned to Teacher {{teacherName}}.',
            reassignedToNTeachers:
              '{{numberOfClasses}} Classes and all associated students have been reassigned to other teachers.',
            teacherHasBeenRemoved: '{{teacherName}} is deleted.',
            title: 'Done!',
          },
          ok: 'Ok',
          payAttention: {
            description:
              'You’re about to delete <strong>{{teacherName}}</strong> and all associated data (classes, students, student progress, and class codes). This action cannot be undone.',
            title: 'Pay attention!',
          },
          selectAction: {
            delete: 'Delete',
            description:
              'You can delete the class or assign the class to another teacher. Complete enrollment changes for individual students separately before deleting the teacher.',
            forAllClasses: 'Same teacher for all classes',
            keepRemainingTeacher: 'Keep "{{name}}"',
            moveAllTo: 'Move all classes to:',
            title: 'Please Select an Action',
            to: 'Class "{{name}}" to',
          },
        },
        editClass: 'Edit Class',
        errorLoading: 'Error loading classes: {{error}}',
        failedToFetch: 'Failed to fetch classes',
        filters: {
          classCode: 'Class Code',
          classCodePlaceholder: 'Search class code',
          classSearchPlaceholder: 'Search class',
          gradeSearchPlaceholder: 'Search grade',
          teacherSearchPlaceholder: 'Search teacher',
        },
        gradeLabel: 'Grade',
        gradeOption1st: '1st',
        gradeOption2nd: '2nd',
        gradeOption3rd: '3rd',
        levelControl: {
          allowIndividualAdvancementLabel: 'Automatic Level Progression',
          allowIndividualAdvancementTooltip:
            'Disabling will stop students in this class who complete a level from automatically continuing to the next level.',
          cancelButton: 'Cancel',
          confirmButton: 'Confirm',
          confirmButtonChangeLevel: 'Change Level',
          confirmButtonDisableLevelProgression: 'Disable Level Progression',
          confirmButtonDisableLevelTest: 'Disable Level Test',
          confirmButtonEnableLevelProgression: 'Enable Level Progression',
          confirmButtonEnableLevelTest: 'Enable Level Test',
          confirmButtonSetLevel: 'Set Level',
          confirmTitle: 'Are you sure?',
          defaultStartingLevelLabel: 'Initial Level',
          defaultStartingLevelPlaceholder: 'Initial Level',
          defaultStartingLevelRequired: 'Please select a default starting level.',
          placementTestRequiredLabel: 'Level Test',
          placementTestRequiredTooltip:
            'Disabling will skip the level placement test for students in this class. You will be required to assign their starting level.',
          warnings: {
            advancementTurnedOff:
              'Turning off automatic level progression means students will stay at their completed level when they finish it. They can repeat activities for more practice.',
            advancementTurnedOn:
              'Turning on automatic level progression means students in this class who have already completed their level will automatically move ahead to the next level on their next login. Any students in this class who complete their level in the future will also move ahead immediately.',
            advancementTurnedOnExistingClass:
              'Turning on automatic level progression means any students who already completed their level will move ahead on their next login. Students who complete their level in the future will also move ahead automatically.',
            advancementTurnedOnNewClass:
              'Turning on automatic level progression means students will move ahead to the next level automatically when they complete their current one.',
            defaultLevelChanged:
              'Changing the class default level will assign the new default to any existing students who have not yet engaged in activities and those who join or are invited to this class in the future. Students in this class who are already engaged will not be affected, and their level might be different than the default. If necessary, you may change existing students’ current level individually or in bulk.',
            defaultLevelChangedExistingClass:
              'This default level will apply to any students who haven’t engaged in activities yet and to any who join this class in the future. Engaged students will not be affected.',
            defaultLevelChangedNewClass:
              'This default level will apply to all students in the class.',
            placementTestTurnedOff:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Students in this class who are already active will not be affected, and their level might be different than the default.',
            placementTestTurnedOffExistingClass:
              'Turning off the level test will assign the class default level to any students who haven’t engaged with any activities yet or who join this class in the future. Engaged students will not be affected.',
            placementTestTurnedOffNewClass:
              'Turning off the level test means all students will be assigned the class default level.',
            placementTestTurnedOn:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Students in this class who are already active will not be affected.',
            placementTestTurnedOnExistingClass:
              'Turning on the level test will remove the class default level from any students who haven’t engaged with any activities yet. They, and any students who join this class in the future, will need to complete the level test first. Engaged students will not be affected.',
            placementTestTurnedOnNewClass:
              'Turning on the level test means all students will need to complete it before starting to engage in activities.',
          },
        },
        newClass: 'Add Class',
        placeholderWriteHere: 'Write here',
        saveClassAndAddLater: 'Save and add students later',
        searchPlaceholder: 'Search classes',
        teachersLabel: 'Teachers (Up to 2)',
        teachersPlaceholder: 'Choose',
        teachersSearchPlaceholder: 'Search teacher',
        title: 'Classes',
        viewClassPage: {
          addStudents: 'Add Students',
          classCodeLabel: 'Class Code',
          coTeacher: 'Co-Teacher (Optional)',
          editClass: 'Edit class',
          metaActiveLabel: 'Active',
          metaInactiveLabel: 'Inactive',
          metaStudentsLabel: 'Students',
          studentColumnName: 'Name & Status',
          teacher: 'Teacher',
        },
        viewClasses: 'View Classes',
        zeroState: {
          buttonText: 'Add Class',
          description:
            'Create a class, add students, and let them begin their English learning journey.',
          filterDescription: 'Try adjusting or resetting the filters to view data.',
          filterTitle: 'No data available for the selected filters.',
          title: 'Create your first class!',
        },
      },
      editSchool: 'Edit',
      general: {
        country: 'Country',
        expirationDate: 'Expiration Date',
        licensesUsage: 'Licenses Used',
        sharedLicenseHint:
          '*The total number of licenses is shared across multiple schools under the same agreement. The number of licenses available may change based on usage by other schools.',
        title: 'School Snapshot',
        totalClasses: 'Total Number of Classes',
        totalStudents: 'Total Number of Students',
        totalTeachers: 'Total Number of Teachers',
      },
      loadingSchoolDetails: 'Loading school details...',
      newClassForm: {
        classNamePlaceholder: 'Write here',
      },
      notFound: 'School not found.',
      students: {
        allLevels: 'All levels',
        allLevelsHint: 'Data reflects the student’s work in all levels.',
        changeLevel_one: 'Change Level',
        changeLevel_other: 'Change Level',
        currentLevel: 'Сurrent level',
        deleteStudents_one: 'Delete Student',
        deleteStudents_other: 'Delete Students',
        displayDataFor: 'Display data for',
        errorLoading: 'Error loading students: {{error}}',
        failedToFetch: 'Failed to fetch students',
        moveStudents_one: 'Move Student',
        moveStudents_other: 'Move Students',
        searchPlaceholder: 'Search students',
        subTitle: '*The starting level was changed.',
        title: 'Students',
        titleOnSelected_one: '1 of {{maxNum}} records selected',
        titleOnSelected_other: '{{num}} of {{maxNum}} records selected',
        zeroState: {
          description:
            'Once you add students, you’ll be able to manage them here and view all their information in one place.',
          filterDescription: 'Try adjusting or resetting the filters to view data.',
          filterTitle: 'No data available for the selected filters.',
          title: 'No students enrolled in the class yet!',
        },
      },
      teachers: {
        addManually: 'Upload File / Add Manually',
        copyLink: 'Copy Link',
        errorLoading: 'Error loading teachers: {{error}}',
        failedToCreate: 'Failed to create teacher',
        failedToFetch: 'Failed to fetch teachers',
        filters: {
          teachers: 'Teacher Name',
          teachersSearchPlaceholder: 'First and last name',
        },
        inviteLinkDescription: 'Copy and share the link below to invite your teachers to log in.',
        inviteYourTeachers: 'Invite Your Teachers',
        linkCopied: 'Link Copied!',
        linkCopiedMessage: 'Now you can share the link with your teachers.',
        newTeacher: 'Add Teacher',
        searchPlaceholder: 'Search teachers',
        title: 'Teachers',
        zeroState: {
          description: 'Add your teachers, so they can create classes and add students.',
          filterDescription: 'Try adjusting or resetting the filters to view data.',
          filterTitle: 'No data available for the selected filters.',
          title: 'Enroll your teachers!',
        },
      },
    },
    schoolsListPage: {
      allLevelsHint: 'Data reflects the student’s work in all levels.',
      classCreated: 'The class has been created successfully!',
      columns: {
        activeUsers: 'Active Users',
        registeredUsers: 'Registered Users',
        schoolAdmin: 'School Admin',
        schoolAdminEmail: 'School Admin Email',
        schoolName: 'School Name & Type',
        status: 'Status',
      },
      createNewSchool: '+ Create New School',
      filters: {
        adminEmail: 'Admin Email',
        schoolAdmin: 'School Admin',
        schoolType: 'School Type',
      },
      newSchool: 'New School',
      studentCreatedSuccessfully: 'Student created successfully!',
      studentsCreatedInClass: 'Students created successfully in class {{className}}!',
      title: 'Schools',
    },
    schoolsTable: {
      addNew: '+ Add New School',
      columns: {
        contact: 'Contact',
        school: 'School',
        students: 'Students',
        teachers: 'Number of Teachers',
      },
      noResults: 'There are no Schools created in this deal.',
    },
    settings: {
      about: 'About',
      about_me: {
        my_account: 'My School',
        my_language: 'My Home Language',
        my_name: 'My Name',
        title: 'About Me',
      },
      account_settings: 'Account settings',
      add_students: {
        add_student: 'Add Student',
        classCreatedDescription:
          'Your students have been emailed instructions for resetting their password. Once your students log in, they will receive a Level Test. Based on the results, they will be placed at their appropriate level and may begin their learning journey.',
        classCreatedDescriptionNoLevelTest:
          'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
        create_students: 'The following students will receive an invitation email:',
        enroll_students: 'Add students',
        enrollment_unsuccessful_description_validation:
          'The following students could not enroll due to validation errors:',
        errors: {
          file_empty: 'The file you are trying to upload is empty.',
          first_name_incorrect: 'First name contains invalid characters or is too long.',
          last_name_incorrect: 'Last name contains invalid characters or is too long.',
          wrong_format:
            'The file format is incorrect. Please ensure you are uploading an Excel (xlsx) file.',
        },
        partial_success_description:
          '{{addedStudents}} of {{totalStudents}} students have successfully enrolled in this class.<br/>They have been sent an email with their temporary password.',
        student_creation_error: ' Students not added. Please try again.',
        studentsSuccessfullyEnrolled: 'The students have been successfully enrolled.',
        upload_file: 'Upload your students Excel file.',
      },
      add_teachers: {
        add_teacher: 'Add Teacher',
        add_teachers_manually: 'Add Manually',
        button_next: 'Next',
        click_to_browse: 'click to browse',
        create_teacher: 'Create Teacher',
        create_teachers: 'The following teachers will receive an invitation email:',
        download: 'Download',
        download_sample: 'a sample Excel (xlsx) file',
        drag_here: 'Drag a file here or ',
        enroll_teachers: 'Add teachers',
        enrollment_unsuccessful: '⚠️ Teacher Addition Unsuccessful!',
        enrollment_unsuccessful_description:
          'The following teachers could not be added because their email has already been used:',
        enrollment_unsuccessful_description_validation:
          'The following teachers could not be added due to validation errors:',
        errors: {
          bad_formatting:
            'Your file is not formatted correctly. <br/> Please check your data and make corrections as needed',
          email_in_use: 'This email address is already registered',
          email_incorrect: 'Please enter a valid email address.',
          file_empty: 'The file you are trying to upload is empty.',
          file_too_large: 'The file is too large. Maximum size allowed is 256KB.',
          first_name_incorrect: 'First name contains invalid characters or is too long.',
          first_name_missing: 'First name is required.',
          first_name_too_long: 'First name can be up to 30 characters.',
          last_name_incorrect: 'Last name contains invalid characters or is too long.',
          last_name_missing: 'Last name is required.',
          last_name_too_long: 'Last name can be up to 40 characters.',
          limit_reached:
            'The maximum number of teachers is 50. <br/> Please remove and upload a new file.',
          limit_reached_description: 'Your class contains the maximum number of teachers allowed.',
          limit_reached_title: 'This class is already full.',
          max_number_of_teachers:
            'The maximum number of teachers is 50. <br/> Please remove and upload a new file.',
          teachers_not_registered: 'Some teachers were not registered',
          username_invalid: 'This username is already taken',
          username_missing: 'Username is required.',
          wrong_format:
            'The file format is incorrect. Please ensure you are uploading an Excel (xlsx) file.',
        },
        invite_teachers: 'Invite Teachers',
        not_enough_licenses:
          'Not enough licenses available to complete this operation. {{available}} licenses available, but {{requested}} teachers were requested.',
        partial_success: '⚠️ Partial Success',
        partial_success_description:
          '{{addedTeachers}} out of {{totalTeachers}} teachers have successfully added.<br/>They have been sent an email with their temporary password.',
        register_your_teachers: 'Register Your Teachers',
        success_description:
          'Your teachers have been sent an email with instructions on resetting their password.<br/>Once they are done, they will be able to begin using Hello Britanica.',
        teacherCreationError: 'Teachers not added. Please try again.',
        teacher_creation_error: 'Teachers not added. Please try again.',
        teachers_added: 'The teachers have been added successfully!',
        upload_attention_text:
          '⚠️ Your organization contains {{curent}}/{{limit}} teachers.<br/>You may add {{certified}} more teachers.',
        upload_attention_text_new_class: '⚠️ Max. {{limit}} teachers',
        upload_file: 'Upload your teachers Excel file.',
        upload_successful: 'Your file has been uploaded successfully.',
      },
      delete_class: {
        classNotEmpty: 'You can’t delete a class that contains students.',
        classNotEmptyDescription:
          'If you would like to delete this class, you must first delete those students. You can do this by opening the student’s profile and clicking the Edit icon.',
      },
      delete_student: {
        tryAgain: 'Try again',
      },
      language_of_study: 'Language of study',
      native_language: 'My Home Language',
      passwordRequirements: {
        atLeastOneLowercase: 'Contains at least 1 lowercase letter',
        atLeastOneNumber: 'Contains at least 1 number',
        atLeastOneSpecial: 'Contains at least 1 special character',
        atLeastOneUppercase: 'Contains at least 1 uppercase letter',
        passwordMinimumLength: '8 characters minimum length',
      },
      preferences: 'Preferences',
      school_id: 'My School',
      suggested_languages: 'Suggested Languages',
    },
    statesListPage: {
      welcomeMessage:
        'This platform allows you to create and manage states for the <strong>Hello Britannica English Learning</strong> Platform. Go ahead and create your first state!',
      welcomeTitle: 'Welcome Administrator!',
    },
    statsCardGroup: {
      averageSessionTime: '📊 Average Time Spent',
      averageSessionTimeEmpty: 'Students haven’t begun activities yet',
      averageSessionTimeTooltip: 'Average time spent by students actively completing activities',
      engagedStudents: '🟢 Engaged Students',
      engagedStudentsEmpty: 'Students haven’t completed any activities yet',
      engagedStudentsTooltip: 'Students who have begun at least one activity',
      engagedTeachers: '🟢 Engaged Teachers',
      engagedTeachersEmpty: 'Teachers did not create classes yet',
      engagedTeachersTooltip: 'Teachers who own at least one class',
      passiveStudents: '🟢 Passive Students',
      passiveStudentsEmpty: 'No students enrolled in the class yet',
      passiveStudentsTooltip: 'Students who haven’t begun any activities',
      totalTimeSpent: 'Total Time Spent',
      totalTimeSpentEmpty: 'Students haven’t begun activities yet',
      totalTimeSpentTooltip: 'Total time spent by students actively completing activities',
    },
    studentDataModal: {
      activities: 'Activities',
      completedLevelNotice:
        "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
      days: {
        friday: 'Fri',
        monday: 'Mon',
        saturday: 'Sat',
        sunday: 'Sun',
        thursday: 'Thurs',
        tuesday: 'Tues',
        wednesday: 'Wed',
      },
      deleteStudentForm: {
        areYouSure: 'Are you sure?',
        cancel: 'Cancel',
        choose: 'Choose',
        close: 'Close',
        delete: 'Delete',
        deletingFailed: 'Deleting failed.',
        deletingFailedDescription:
          'Our servers are not responding. Please try again. If the problem persists, please contact us at <a href="mailto:{{email}}">{{email}}</a>',
        description:
          'Deleting this student will permanently remove them from the platform. This student will no longer be able to log in and all progress data will be lost. Please provide a reason:',
        oops: 'Oops!',
        reason: 'Reason',
        reasons: {
          aClericalError: 'A clerical error',
          other: 'Other',
          requestedToBeRemoved: 'The student or parent requested to be removed',
        },
        tryAgain: 'Try again',
        why: 'Why?',
      },
      editForm: {
        ChooseAnotherLevel: 'Choose another level',
        areYouSure: 'Are you sure?',
        cancel: 'Cancel',
        changingLevel: 'Changing the student’s level will delete their progress and history!',
        currentLevel: 'Current level',
        deleteStudent: 'Delete student',
        edit: 'Edit',
        email: 'Email',
        errors: {
          anErrorOccurred: 'An error has occurred',
          email_incorrect: 'Please enter a valid email address.',
          first_name_incorrect: 'First name contains invalid characters or is too long.',
          first_name_missing: 'First name is required.',
          first_name_too_long: 'First name can be up to 30 characters.',
          last_name_incorrect: 'Last name contains invalid characters or is too long.',
          last_name_missing: 'Last name is required.',
          last_name_too_long: 'Last name can be up to 40 characters.',
        },
        firstname: 'First Name',
        interfaceLanguage: 'Interface language',
        language: 'Language',
        lastname: 'Last Name',
        level: 'Level',
        save: 'Save',
        userDataSuccessfullyUpdated:
          'The details have been successfully updated. Please ask student to refresh the page to see the change.',
        username: 'Username',
        yes: 'Yes',
      },
      firstLogin: 'First login',
      interfaceLanguage: 'Interface language',
      level: 'Level',
      progress: 'Progress',
      report: {
        activitiesCompletedInLevel: 'Activities Completed in Level {{level}}',
        allLevelsAvgTime: "📊 All level's avg. time",
        attemptsAndHints: 'Attempts & Hints',
        avgAttemptsPerActivity: 'Average per activity',
        avgHintsPerActivity: 'Avg. hints per activity',
        avgPerWeek: 'Avg. per week',
        avgProgress: 'Average Progress',
        avgSkillScores: 'Skill Scores',
        avgStreakPerWeek: 'Avg. streak per week',
        classDataNotAvailable: 'The data for this class is not available.',
        continuousEngagement: 'Continuous Engagement',
        date: 'Date',
        engagement: 'Engagement',
        failureRate: 'Fail Rate',
        generateReport: 'Generate Report',
        inCurrentLevel: 'In Current Level',
        level: 'Level',
        longestStreak: 'Longest streak',
        overallProgressInLevel: 'Overall Progress in Level {{level}}',
        passRate: 'Pass Rate',
        previous7Days: 'Previous 7 days',
        progress: 'Progress',
        skippedActivitiesComment: '* Skipped activities are included in total activities',
        streakLast7Days: 'Streak over last 7 days',
        streakLength: 'Streak Length',
        studentName: 'Student Name',
        studentReport: 'Student Report',
        timeSpentOnActivites: 'Time Spent on Activites',
        total: 'Total',
        totalHintsUsed: 'Total hints used',
        totalInPrev7Days: 'Total in prev. 7 days',
        tryAgainLater: 'Try again later!',
        weCouldNotProduce: 'The report cannot be generated at the moment.',
        weStillDontHaveAll: "We still don't have all the necessary information.",
      },
      schoolName: 'School Name',
      selfPracticeStreak: 'Self Practice Streak',
      thisStudentIsInactive:
        'This student is inactive. They have been invited to the class, but have not yet started the initial level placement test.',
      thisStudentIsLevelTestIncomplete:
        'This student has not yet completed the initial level placement test. Once they have done so, you’ll be able to see their progress.',
      topics: 'Topics',
      totalProgressWithinLevel: 'Total Progress within the level',
      unitData: {
        activities: 'Activities',
        canDo: 'Can Do',
        completed: 'Completed',
        failed: 'Failed',
        level: 'Level',
        skipped: 'Skipped',
        somethingWentWrong: 'Something went wrong. Please, try again later',
        stars: 'Stars',
        toggle: 'Toggle',
        topics: 'Topics',
        totalActivities: 'Total Activities',
      },
      viewPerformance: 'View Performance',
    },
    studentMetricsDashboard: {
      charts: {
        avgStudentGrowth: {
          averageGrowth: 'Average Growth',
          month: 'Month',
        },
        kpis: {
          averageTimeSpent: {
            tooltip: 'Average time spent by students actively completing activities',
          },
          passRate: {
            tooltip: 'The percentage of activities that were successfully passed.',
          },
          totalTimeSpent: {
            tooltip: 'Total time spent by students actively playing',
          },
        },
        studentsAcrossSkills: {
          tooltipStudents: 'students',
        },
      },
      drillDown: {
        students: {
          columns: {
            classNameAndGrade: 'Class & Grade',
            coTeacherName: 'Co-Teacher Name',
            nameAndCoTeacher: 'Name & Co-Teacher',
            nameAndTeacher: 'Name & Teacher',
          },
        },
      },
      emptyState: {
        filter: {
          description: 'Try adjusting or resetting the filters to view data.',
          title: 'No data available for the selected filters.',
        },
        noStudents: {
          description:
            'Once you add students, you’ll be able to manage them here and view all their information in one place.',
          title: 'No students added yet!',
        },
      },
      filters: {
        coTeacher: 'Co-Teacher Name',
        fail: 'Fail',
        pass: 'Pass',
        score: 'Score',
        status: 'Status',
        statusSearchPlaceholder: 'Search status',
      },
      totalStudents: 'Engaged Students: {{totalStudents}} ',
    },
    tabbedCard: {
      addNew: '+ Add New',
      tabs: {
        districts: 'Districts',
        schools: 'Schools',
      },
    },
    topic: 'Topic',
    university: 'university',
    validation: {
      mustBeAtLeastCharacters: 'This field must be at least {{length}} characters',
    },
  },
  adminInstructions: 'Admin Instructions',
  again: 'again',
  all: 'All',
  allDone: 'All done!',
  allLevels: 'All Levels',
  almostFinish: 'Almost finished!',
  almostMadeIt: 'Almost made it',
  almostThere: "You're almost there...",
  amazing_job: 'Amazing job!',
  anErrorOccurred: 'An error has occurred',
  andInviteYourStudents: 'and invite your students',
  andThenInvite: 'and then invite your students to join the class',
  answerNotAccepted: 'Answer not accepted',
  answeredIncorrectly: 'answered incorrectly.',
  appName: 'Hello Britannica',
  appTitle: 'Britannica',
  areYouReadyForTheQuiz: "Do you think you're ready for the game?",
  areYouSure: 'Are you sure?',
  asSoonAsTheyStart: 'Once your student changes their temporary password, they will become active',
  asSoonAsTheyStartGoogle:
    'Your class has been created. Now you need to add your students! <br/> Use the Sync button to board your students from your class in Google-Classroom to the "Hello" Platform.',
  assessment: 'Assessment',
  assessments: 'Assessments',
  atLeastOneLowercase: 'Contains at least 1 lowercase letter',
  atLeastOneNumber: 'Contains at least 1 number',
  atLeastOneSpecial: 'Contains at least 1 special character',
  atLeastOneUppercase: 'Contains at least 1 uppercase letter',
  avgAttempts: 'Attempts',
  avgCurrentLevel: 'Average Current Level',
  avgCurrentLevelTooltip: 'The average current level of students.',
  avgCurrentLevel_mobile: 'Average Current Level',
  avgFailureRate: '❌Average Fail Rate',
  avgLevel_mobile: 'Avg. level',
  avgPassRate: '✅ Avg Pass Rate',
  avgProgress: 'Average progress',
  avgProgressTooltip: 'The average progress of students within their current level.',
  avgProgress_mobile: 'Average progress',
  avgScore: 'Average Score',
  avgScoreTooltip: 'The average score of students across activities in their current level.',
  avgScore_mobile: 'Average Score',
  avgTimeSpent: 'Avg. Time Spent',
  avgTimeSpentTooltip: 'Average of all time spent by students actively playing.',
  avgTimeSpent_mobile: 'Avg. Time Spent',
  back: 'Back',
  backHome: 'Back Home',
  backOnline: 'It looks like you are back online!',
  backOnlineActivities: 'Let’s go back to the skipped activities.',
  bimloaFilter: {
    all: 'All',
    close: 'Close',
    filter: 'Filter',
    filterBy: 'Filters',
    max: 'Max',
    min: 'Min',
    reset: 'Reset',
    resetAll: 'Reset All',
    to: 'to',
  },
  britannicaEducationWith: 'Britannica Education with',
  byClickingOn:
    'By clicking on the student’s name, you’ll see how they are performing in each skill and how often they use the app . You can also decide which interface language they should use.',
  cameraPermission: {
    button: 'Try Again',
    text: 'Camera permission denied. Please allow camera access in your browser settings.',
  },
  canDo: 'Can Do',
  cancel: 'Cancel',
  change_password: 'Change Password',
  changingLevel: 'Changing the student’s level will delete their progress and history!',
  characters: 'Characters',
  checkInSpamMessage: 'Didn’t receive it? Try checking your <0>spam</0> folder.',
  choose: 'Choose',
  chooseAvatar: 'Choose Avatar',
  chooseGrade: 'Choose grade',
  chooseTheCorrectAnswer: 'Choose the correct answer to fill in the sentence:',
  chooseUsername: 'Choose Username',
  chooseYourClasses: 'Choose the classes you want to add from Google Classroom',
  chooseYourFavoriteAvatar: 'Choose your favorite avatar and color',
  city: 'City or District',
  class: 'Class',
  classCode: 'Class Code',
  classCodeClassLimitReached: 'Class Subscription Limit Reached',
  classCodeDealInvalidCode:
    'Invalid code. Please check your entry or contact your teacher for a new class code.',
  classCodeDealLimitReached: 'School Subscription Limit Reached',
  classCodeDealNotActive: 'The link that you are trying to reach already expired',
  classCodeDealNotValid:
    'The class code you entered has expired. Please check your entry or contact your teacher for a new class code.',
  classCodeNotActive:
    'Class code is not active. Please check your entry or contact your teacher for a new class code.',
  classCreated: 'The class has been created successfully!',
  className: 'Class Name',
  classReport: 'Class Report',
  classWasDeleted: 'It looks like “{{className}}” class has been deleted from Google Classroom',
  classWasDeletedDescription: 'you can not perform this action until the deleted class is removed.',
  classes: 'Classes',
  classesDeleted: 'The class has been deleted successfully!',
  classesDeletedDescription: 'You will no longer have the option to view or edit this class',
  classesImported: 'Your classes have been imported!',
  clickHere: 'Click here!',
  close: 'Close',
  closeMenu: 'Close Menu',
  coTeacher: 'Co-Teacher',
  cognitoErrors: {
    CodeMismatchException: 'Invalid verification code provided, please try again.',
    ExpiredCodeException: 'Invalid code provided, please request a code again.',
    LimitExceededException: 'Attempt limit exceeded, please try after some time.',
    NetworkError: 'Network error. Please check your internet connection and try again.',
    NewPasswordRequiredSessionExpired: 'Session expired. Go back and try again.',
    NotAuthorizedException: 'Invalid email or password',
    UserNotConfirmedException:
      'Your account is not verified. Please enter the verification code sent to your email.',
    UsernameExistsException: 'This username is already taken',
  },
  coins: 'Coins',
  coinsInstructions: 'You can use them to get help during the games.',
  coinsWillBeLost: 'and the coins you won will be lost',
  comingSoon: 'Coming<br/>Soon',
  complete: 'Complete',
  completeImportError:
    'Your classes could not be imported because they have already been imported by another teacher.',
  completed: 'Completed',
  completedActivities: 'Total activities completed in this level',
  completedLevelNotice:
    "Student has no more new activities. You may manually advance their level if your school's curriculum allows.",
  confirmPassword: 'Confirm Password',
  contactAdmin: 'Please contact your school administrator for guidance.',
  contactOurTeam: 'Contact our team at',
  contactOurTeamWithQuestions: 'Contact our team with questions and concerns.',
  contactTeacher: 'Contact your teacher to get a temporary password!',
  contactUs: 'Contact Us',
  contactUsSubtitle: 'Our team will provide you answers and guidance.',
  continue: 'Continue',
  continueOnWeb: 'Continue on web',
  continueQuiz: 'Continue Game',
  continueToQuestions: 'Continue To Questions',
  continue_level_test: 'Continue Level Test',
  copy: 'Copy',
  copyInvitationLink: 'Copy Invitation Link',
  copyLink: 'Copy Link',
  copyTemporaryPassword: 'Copy Password',
  copyTemporaryPasswordDescription:
    'You can copy the password and send it to {{firstName}} {{lastname}}!',
  copyright: '2026 Encyclopedia Britannica, Inc.',
  couldNotLocate: 'We couldn’t locate the page you’re looking for.',
  country: 'Country',
  create: 'Create',
  createClass: 'Add Class',
  createClassCode: 'Create Class Code',
  createNewClass: 'Add Class',
  createYourClass: 'Create your class and invite your students',
  createYourFirstClass: 'Create your first class',
  createYourFirstClassDescription:
    'Set up your class, then upload a list of students you would like to enroll in that class. Then invite your students to join.',
  currentLevel: 'Current level',
  current_password: 'Current Password',
  customYourLearning: "Soon we'll be able to customize your learning experience!",
  dashboard: 'Dashboard',
  date: 'Date',
  dealLimitReachedMessageAdminDescription:
    'No additional students can be added. Please contact us for assistance.',
  dealLimitReachedMessageAdminTitle: 'Your school’s license limit has been reached.',
  dealLimitReachedMessageDescription:
    'No additional students can be added. Please contact your school administrator for guidance.',
  dealLimitReachedMessageTitle: 'Your school’s user limit has been reached.',
  dearSchoolAdmin: 'Dear school administrator, you’ve been',
  dearTeacher: 'Dear teacher, you’ve been invited to join',
  delete: 'Delete',
  deleteClass: 'Delete class',
  deleteClasses: 'Delete Classes',
  deleteClassesAttention:
    "Please pay attention that in case of class deletion, all its data will be removed and can not be restored. All students' progress will be deleted.",
  deleteClassesDescription:
    "Please pay attention that in case of class deletion, all its data will be removed and can not be restored. All students' progress will be deleted.",
  dictionary: 'Dictionary',
  didntQuiteHearThat: "Didn't quite hear that.",
  doYouHaveAClassCode: 'Do you have a class code?',
  doingGreat: "You're doing great!",
  done: 'Done',
  dontKnow: "Don't Know",
  downloadAndView: 'Download and view',
  downloadClassReport: 'Download Class Report',
  downloadList: 'Download List',
  edit: 'Edit',
  editClass: 'Edit class',
  editClassClassNameAlreadyExists: 'A class with this name already exists',
  editClassInvalidClassName: 'Class name required',
  editClassInvalidClassNameFormat: 'Class name contains invalid characters.',
  editClassInvalidGrade: 'Grade required',
  editClassInviteNewStudent: 'Add New Students',
  editClassStudentFullClassDescription:
    'Your class contains the maximum<br/>number of students allowed.',
  editClassStudentFullClassTitle: 'This class is already full.',
  editClassStudentNewStudentAddedDescription:
    'They have been sent an email with instructions on resetting their password. Once your student logs into the platform, they will receive a level test and be placed at their appropriate level and begin their learning journey.',
  editClassStudentNewStudentAddedTitle: 'has been invited!',
  editClassStudentStatus: 'Status',
  editClassStudentStatusActive: 'Active',
  editClassStudentStatusInactive: 'Inactive',
  email: 'Email',
  emailExample: 'example@gmail.com',
  emailOrUsername: 'Email or username',
  emailVerification: 'Email Verification',
  englishLearningJourney: 'English-learning journey with Hello Britannica.',
  englishLearningJourneyMorfix: 'English-learning journey with Hello Britannica.',
  englishSkillsAssessments: 'English Skills Assessments',
  enterCodeHere: 'Enter code here',
  enterNewPassword: 'Enter new password',
  enterVerificationCode: 'Enter Verification Code',
  enterVerificationCodeAndNewPassword: 'Enter verification code and new password',
  enterVerificationCodeHelpText: 'Enter the code you received from your referral partner.',
  enterYourAnswerHere: 'Enter your answer here',
  error: {
    apiMessages: {
      accessDenied: 'Access denied.',
      accessDeniedOrStudentNotFound: 'Access denied or the student is not found.',
      accessDeniedOwnSchoolOnly: 'Access denied - you can only access data from your own school.',
      atLeastOneNameRequired: 'At least one field (first name or last name) must be provided.',
      atLeastOneTeacherRequired: 'At least one teacher must be assigned to the class.',
      atLeastOneUserRequired: 'At least one user is required.',
      classCodeRequired: 'Class code is required.',
      classCodeValidationFailed: 'Failed to process the class code validation response.',
      classReportNotFound: 'Class report not found.',
      dealNotFound: 'Deal not found.',
      dealNotFoundOrInvalid: 'Deal not found or is invalid.',
      dealValidationFailed: 'Deal validation failed.',
      errorCheckingTeacherDeletionEligibility:
        'An error occurred while checking teacher deletion eligibility. Please, try again later.',
      errorCreatingDeal:
        'An error occurred while creating or updating the deal. Please, try again later.',
      errorCreatingGroup: 'An error occurred while creating the group. Please, try again later.',
      errorCreatingPrincipalAdmin:
        'An error occurred while creating the principal admin. Please, try again later.',
      errorDeletingUser: 'An error occurred while deleting the user. Please, try again later.',
      errorProcessingDeletionRequest:
        'An error occurred while processing the deletion request. Please, try again later.',
      errorProcessingTeacherDeletionActions:
        'An error occurred while processing teacher deletion. Please, try again later.',
      errorSigningOut: 'An error occurred while signing out. Please, try again later.',
      errorValidatingClassCode:
        'An error occurred while validating the class code. Please, try again later.',
      errorValidatingDeal: 'An error occurred while validating the deal. Please, try again later.',
      failedToCreateAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateComprehensiveAccount: 'Failed to create the account. Please, try again later.',
      failedToCreateGroup: 'Failed to create a group. Please, try again later.',
      failedToCreateRegion: 'Failed to create region. Please, try again later.',
      failedToCreateStudent: 'Failed to create student. Please, try again later.',
      failedToDeleteGradeConfiguration:
        'Failed to delete grade configuration. Please, try again later.',
      failedToDeleteTeacher: 'Failed to delete teacher. Please, try again later.',
      failedToDeleteTeacherWithActions:
        'Failed to process teacher deletion. Please, try again later.',
      failedToDeleteUser: 'Failed to delete user. Please, try again later.',
      failedToGenerateAdminGuideUrl:
        'Failed to generate the admin guide URL. Please, try again later.',
      failedToProcessUserCreation:
        'Failed to process the user creation request. Please, try again later.',
      failedToRegisterDevice: 'Failed to register the device. Please, try again later.',
      failedToRetrieveDealList: 'Failed to retrieve the deal list.',
      failedToRetrieveRegions: 'Failed to retrieve regions.',
      failedToRetrieveStudentMetrics: 'Failed to retrieve student metrics.',
      failedToRetrieveStudentSkillPerformance: 'Failed to retrieve student skill performance data.',
      failedToRetrieveUserList: 'Failed to retrieve the user list.',
      failedToRetrieveUserStatistics: 'Failed to retrieve user statistics.',
      failedToSaveGradeConfiguration:
        'Failed to save grade configuration. Please, try again later.',
      failedToSetInterfaceLanguage:
        'Failed to set the interface language. Please, try again later.',
      failedToSetStudentSettings: 'Failed to set student settings. Please, try again later.',
      failedToSetUserAvatar: 'Failed to set the user avatar. Please, try again later.',
      failedToSignOut: 'Failed to sign out. Please, try again later.',
      failedToUpdateActivities: 'Failed to update user activities.',
      failedToUpdateGroup: 'Failed to update group. Please, try again later.',
      failedToUpdateTeacher: 'Failed to update teacher. Please, try again later.',
      forbidden: 'Action forbidden.',
      googleUserNotFound: 'Google user not found.',
      gradeConfigurationNotFound: 'Grade configuration not found.',
      groupDeletionFailed: 'Group deletion failed. Please, try again later.',
      groupNotFound: 'Group not found.',
      groupsNotFound: 'Groups not found.',
      groupsReportNotFound: 'Groups report not found.',
      groupsReportTimedOut:
        'The request timed out while retrieving the groups report. Please, try again later.',
      incompleteResponseData: 'The response was successful, but the data was incomplete.',
      incompleteStudentCreationResponse:
        'The response was successful, but the data was incomplete. Students may have been created – please refresh and verify.',
      internalErrorCreatingToken: 'An internal server error occurred while creating the token.',
      invalidAdminManagementResponse: 'Invalid response from the admin management service.',
      invalidDealName: 'Invalid deal name.',
      invalidInputs: 'One or more inputs are invalid.',
      invalidIntsProvided: 'Please enter valid numbers.',
      invalidLevelProvided: 'Invalid level provided.',
      invalidNotificationsResponse: 'Invalid response from the notifications service.',
      invalidOrgOrDeal: 'Invalid request: missing organization details or deal ID.',
      invalidRequest: 'Invalid request.',
      invalidRequestParameters: 'Invalid request parameters.',
      invalidSchoolDealNames:
        'School name, deal name, and school manager names must not contain numbers, and first/last names must not exceed 40 characters.',
      invitationLinkNotFound: 'Invitation link not found.',
      languagePreferencesNotFound: 'Language preferences not found for this school.',
      levelSummariesNotFound: 'Level summaries not found.',
      noDataFound: 'No data found.',
      noDataFoundForIds: 'No data found for the provided IDs.',
      noRegionsFound: 'No regions found.',
      notificationsServiceNotConfigured: 'The notifications service is not configured.',
      operationNotFound: 'Operation not found.',
      organizationDoesNotExist:
        'The organization does not exist. No new users can be registered at this time.',
      ownDevicesOnly: 'You can only register devices for your own account.',
      reportRequestTimedOut:
        'The request timed out while generating the report. Please, try again later.',
      requestBodyRequired: 'Request body is required.',
      requestCanceled: 'The request was cancelled. Please, try again later.',
      requestCanceledRetry: 'The request was cancelled. Please, try again later.',
      requestCannotBeNull: 'The request cannot be empty.',
      requestNotProcessed: 'The request did not process successfully. Please, try again later.',
      schoolAndTeacherIdRequired: 'School ID and Teacher ID are required.',
      schoolIdRequired: 'School ID is required.',
      schoolNotFound: 'School not found.',
      searchQueryRequired: 'Search query is required.',
      studentCreationTimedOut:
        'The request timed out while creating students. The operation may still be processing — please wait a moment and refresh to verify.',
      studentDataNotFoundOrDenied: 'Student data not found or access is denied.',
      studentProgressNotFound: 'Student progress data not found.',
      studentReportNotFound: 'Student report not found.',
      studentRequestRequired: 'The student request cannot be empty.',
      studentsNotFound: 'Students not found.',
      studentsReportNotFound: 'Students report not found.',
      studentsReportTimedOut:
        'The request timed out while retrieving the students report. Please, try again later.',
      teacherDetailsNotFound: 'Teacher details not found.',
      teacherIdRequired: 'Teacher ID is required.',
      teacherNotFound: 'Teacher not found.',
      teachersNotFound: 'Teachers not found.',
      teachersReportNotFound: 'Teachers report not found.',
      teachersReportTimedOut:
        'The request timed out while retrieving the teachers report. Please, try again later.',
      tokenCreationFailed: 'Token creation failed. Please, try again later.',
      unableToParseServerResponse:
        "Unable to parse the server's response. Students may have been created — please refresh and verify.",
      unableToProcessRequest: 'Unable to process your request. Please, try again later.',
      unableToRetrieveGroupsReport:
        'Unable to retrieve the groups report. Please check your request and try again.',
      unableToRetrieveStudentsReport:
        'Unable to retrieve the students report. Please check your request and try again.',
      unableToRetrieveTeachersReport:
        'Unable to retrieve the teachers report. Please check your request and try again.',
      unauthorized: 'Action unauthorized.',
      unexpectedDealServiceResponse: 'Unexpected response from the deal service.',
      unexpectedWithRef:
        'An unexpected error occurred. Please try again or contact support. (Ref: {{ref}})',
      unregisterOwnDevicesOnly: 'You can only unregister your own devices.',
      updateRequestBodyRequired: 'The update request body is required.',
      updatesRequired: 'Updates are required.',
      userAuthContextRequired: 'User authentication context is required.',
      userDoesNotExist: 'The requested user does not exist.',
      userIdentityRequired: 'User identity is required.',
      userNotFound: 'User not found.',
      userOrgDetailsNotFound: 'User organization details not found.',
      userPartiallyDeleted:
        'User deleted only from some systems, but not from all. Please try again or contact support.',
      validTeacherOrgIdRequired: 'A valid Teacher ID and Organization ID are required.',
      verificationCodeInvalid: 'The verification code is invalid.',
    },
    somethingWentWrong: 'Something went wrong. Please, try again later',
    wafBlocked: {
      description:
        'This action has been temporarily blocked for security reasons. Please try again in a few minutes.',
      eyebrow: 'Access Blocked',
      title: 'Oops...',
    },
    weHadAProblem: 'Oops! We had a problem.',
  },
  exampleEmail: 'example@gmail.com',
  exampleSentences: 'Example sentences',
  examples: 'examples',
  exit: 'Exit',
  exploreEngaging:
    'Explore engaging lessons and fun activities that will make English learning enjoyable and effective.',
  extra: 'Extra',
  extraCoins: 'Extra Coins',
  failed_quiz_message_first: "You didn't pass this activity, so no stars.",
  failed_quiz_message_passed:
    "You didn't pass this time, but don't worry. Your previous score has been saved.",
  failureRate: 'Fail Rate',
  fewMoreSeconds: 'Few more seconds',
  fieldIsMandatory: 'This field is mandatory',
  filter: 'Filter',
  finalAssessment: 'Final Assessment',
  finalEnglishLevelTest: 'Final English level Test',
  finishActivity: 'Finish activity',
  finishGameText:
    'You’ve completed your Hello Britannica course.<br/> All of your activities will remain unlocked so you may go back and practice ',
  finishToLevelUp: 'Finish to level up!',
  finishUnitSuccessText:
    'You’ve completed the unit {{completedUnitName}}. You’re now ready to begin {{nextUnitName}}. Remember, you can always go back to this unit to review.',
  firstLogin: 'First login',
  firstname: 'First Name',
  focus: 'Focus!',
  for: 'for',
  forgotPassword: 'Forgot password',
  fridayShort: 'Fri',
  from: 'From',
  fullVersionAvilableOnlyOnDesktop: 'Full version available only on desktop',
  generateClassReport: 'Generate Class Report',
  generateReport: 'Generate Report',
  genericTable: {
    bimloaFilter: {
      all: 'All',
      close: 'Close',
      from: 'From:',
      reset: 'Reset',
      resetAll: 'Reset All',
    },
    dropDown: {
      placeholder: 'Choose',
    },
    noResultsForSearch: 'No results found for your search or filter.',
  },
  getApp: 'Get the app',
  getFullExperience: 'Get the full experience with the Hello Britannica app',
  getStarted: 'Get Started',
  giveFeedback: 'Contact Us',
  goAheadAndShareThisLinkWithYourStudentsNow:
    'Go ahead and share this link with your students now. ',
  goBack: 'Go Back',
  goForward: 'Go Forward',
  goToLevelTest: 'Go to Level Test',
  go_back_btn: 'Go Back Button',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  goodJob: 'Good job!',
  goodLuck: 'Good luck!',
  goodMorning: 'Good morning',
  goodNight: 'Good night',
  googleDataAdded: 'The classes you selected were successfully added!',
  googleDataAddedDescription:
    'Once your students log in to the platform, they will need to take a level test. Based on the results, they will be placed at their appropriate level and begin their learning journey.',
  googleDataSynced: 'Your data has been synced!',
  googleDataSyncedDescription: 'All data between Google Classroom and Hello is now synced.',
  googleStudentIsInactive:
    'This student is inactive. They have been invited to the class, but have not yet started the initial level placement test.',
  googleStudentsAlreadyInOtherGroups:
    'The following students could not be added to the class because they already belong to another class:',
  grade: 'Grade',
  grade_1: '1st',
  grade_10: '10th',
  grade_11: '11th',
  grade_12: '12th',
  grade_13: 'University',
  grade_14: 'None',
  grade_2: '2nd',
  grade_3: '3rd',
  grade_4: '4th',
  grade_5: '5th',
  grade_6: '6th',
  grade_7: '7th',
  grade_8: '8th',
  grade_9: '9th',
  grade_none: 'None',
  grade_university: 'University',
  grammar_tip: 'Grammar Tip',
  great: 'Great!',
  greatJob: 'Great job!',
  guides: 'Guides',
  hello: 'Hello',
  helloBritannica: 'Hello Britannica',
  helloLoader: 'Hello',
  helloTeacher: 'Hello 👋🏻',
  help: 'Help',
  hi: 'Hi',
  hints: 'Hints',
  hints_options: {
    add_more_time: 'Add Time on Clock',
    hear_the_english_word: 'Hear the English word',
    remove_a_letter: 'Remove a letter',
    remove_one_answer: 'Remove one answer',
    reveal_a_pair: 'Reveal a pair',
    see_the_translation: 'See the translation',
    see_the_word: 'See the word',
    show_a_letter: 'Show a letter',
  },
  homepage: 'Home Page',
  howDidYouDo: 'How did you do?',
  howsYourEnglish: "How's Your English?",
  iAgree: 'I Agree',
  iAgreeTo: 'I agree to the',
  iAmReady: "I'm Ready!",
  iDidntUnderstand: 'I didn’t understand. Please try again.',
  iDoNotAgree: 'I Don’t Agree',
  id: 'ID',
  illDoItLater: 'I’ll do it later',
  importClasses: 'Import Class',
  importYourFirstClass: 'Import your first class from Google Classroom!',
  importYourFirstClassDescription:
    'Import your class from Google Classroom to Hello, and then your students will be able to join',
  improveYourLastActivities: 'Improve your last activities',
  in_order_to_start: 'In order to start your learning journey, we need to',
  inactive: 'Inactive',
  incorrect: 'Incorrect!',
  incorrect_answer: 'incorrect.',
  initialLevelTest: 'Initial Level Test',
  interfaceLanguage: 'Interface language',
  interface_language: 'Interface language',
  invalidCode: 'Invalid code',
  invalidEmail: 'Invalid email',
  invalidEmailOrUsername: 'Invalid email or username',
  invalidField: 'Invalid field',
  invalidFirstname: 'First name contains invalid characters',
  invalidLastname: 'Last name contains invalid characters',
  invalidOrganizationName: 'School name contains invalid characters.',
  invalidPassword: 'Invalid password',
  invalidUsername: 'Username cannot contain space.',
  invalidUsernameOrPassword: 'Invalid username or password',
  invalidUsernameinForgotPassword:
    'Something went wrong with username "{{username}}". Please contact your teacher for further help.',
  invitationLink: 'Invitation Link',
  invitationLinkWontChange: "Don't worry- invitation link won't change",
  inviteYourStudents: 'Invite Your Students',
  inviteYourTeachers: 'Invite your teachers to join',
  invitedToJoin: 'invited to join Hello Britannica.',
  invitedToJoinMorfix: 'invited to join Hello Britannica.',
  isNotEnglish: 'For this activity, your writing needs to be in English. Please try again.',
  itLooksLikeYourLevel:
    'It looks like Level {{level}} is the right fit for now. Keep practicing, and you’ll keep improving!',
  itLooksLikeYourLevelMax:
    'Great job! It looks like Level {{level}} is the right fit for you. Let’s jump in.',
  itsTime: "It's time to choose whether you're ready for the game or not,",
  joinNow: 'Join Now',
  keepGoing: 'Keep going',
  keepPlaying: 'Keep playing!',
  keepPracticing: 'Keep practicing',
  know: 'Know',
  know_your_level: 'know your level of English.',
  language: 'Language',
  language_of_study: 'Language of study',
  languages: {
    ar: 'Arabic',
    en: 'English',
    es: 'Spanish',
    he: 'Hebrew',
    pt: 'Portuguese',
  },
  lastLogin: 'Last login',
  lastUncorrectPronounce: 'Skip to the next question.',
  lastUnitCongratulation:
    'You’ve completed Level <strong>{{currentLevel.name}}</strong><br/> and you’re on your way to Level <strong>{{nextLevel.name}}</strong>.',
  lastname: 'Last Name',
  learn: '{{lessons}} lessons available',
  leave_level_test_and_sign_out: 'Leave level test?',
  letsAssess:
    'Let’s check your English with a short quiz. That way, we can provide you with the best learning experience. It may take anywhere from 5-15 minutes based on your performance. Are you ready?',
  letsBegin: "Let's Begin",
  letsFinish: "Lets's Finish",
  letsGo: "Let's Go",
  letsKeepLearning: "let's keep learning!",
  letsSee: "Let's see how well you know your vocabulary.",
  level: 'Level',
  levelChanged: 'Your level has changed',
  levelChangedDescription:
    'Please note: your previous progress and activity have been cleared to reflect your new learning path.',
  levelChangedDown: 'Your teacher has adjusted your learning level.',
  levelChangedDownDescription:
    'This is to help you strengthen key skills before moving forward — you’ve got this.',
  levelChangedUp: 'Your teacher has upgraded you to a higher learning level.',
  levelChangedUpDescription: 'Keep up the great work and continue challenging yourself!',
  levelName_1: 'Starter (Pre-A1)',
  levelName_2: 'Beginner (A1)',
  levelName_3: 'Pre-Intermediate (A2)',
  levelName_4: 'Intermediate (B1)',
  levelName_5: 'Upper Intermediate (B2)',
  levelName_6: 'Advanced (C1)',
  levelTest: 'Level test',
  levelTestIncomplete: 'Level Test Incomplete',
  levelTestPausedDescription:
    'The last {{count}} questions will not be saved and you will need to repeat them again.',
  level_test: 'Level Test',
  linkCopied: 'Link Copied!',
  listen_tip: 'Listen Tip',
  listeningTapToFinish: 'Click to send',
  loginFromDifferent: 'Log in from different account',
  logout: 'Sign Out',
  longClassName: 'Class name can be up to 40 characters.',
  melingoCalculateYourLevel: 'We’re calculating your level ...',
  memoryGameTitle: 'Flip cards to find six matches between texts and images.',
  menu_button: 'Menu Button',
  message: 'Message',
  mgWebsite: {
    loginFormButton: 'Continue with Google',
    loginFormSubTitle:
      ' <div>Click below to log in with your</div> <div>Google account – it’s fast, simple, and secure!</div> ',
    loginFormTitle: 'Hey, great to see you!',
  },
  microphoneRestricted: 'Microphone access is restricted on your browser',
  missingGooglePermissionsPopup: {
    button: 'Update Permissions',
    description: 'After your approval, you will be able to start your journey with Hello!',
    title: 'Please grant access to “Hello”',
  },
  mondayShort: 'Mon',
  months: {
    apr: 'Apr',
    aug: 'Aug',
    dec: 'Dec',
    feb: 'Feb',
    jan: 'Jan',
    jul: 'Jul',
    jun: 'Jun',
    mar: 'Mar',
    may: 'May',
    nov: 'Nov',
    oct: 'Oct',
    sep: 'Sep',
  },
  multiSelectDropDown: {
    loadMore: 'Load more',
    loading: 'Loading...',
    noResults: 'No results found',
    removeAll: 'Remove all',
    selected: 'selected',
    typeText: 'Type text to search',
  },
  myPrivateTutor: 'My Private Tutor',
  myProfile: 'My Profile',
  myProgress: 'My Progress',
  myProgressCompletedNotice:
    'Congratulations! Your assigned level is complete. Revisit these activities anytime for more practice.',
  my_tutor_page: {
    avatarLabel: 'AI-generated',
    commonMistakeDescription:
      'You can practice your enhancements or see the relevant conversation ',
    commonMistakes: 'Language Insights',
    completedActivities: '{{numberOfCompletedActivities}} Completed! Well Done! 🏆',
    filterOptions: {
      enhancementArea: 'Mistake Type',
      enhancementAreaSearchPlaceholder: 'Search Mistake Type',
      score: 'Score',
      status: 'Activity Type',
      statusSearchPlaceholder: 'Search Activity Type',
    },
    group: {
      filters: {
        all: 'All',
        currentDate: 'Specify Date',
        date: 'Conversations Dates',
        last7days: 'Last 7 Days',
        level: 'Current Level',
        rangeDate: 'Range',
        topic: 'Topics',
      },
      table: {
        avgConversationTime: 'Avg. Conversation Time',
        conversation: 'Conversations',
        lastConversation: 'Last Conversation',
        lastTopic: 'Last Topic',
        level: 'Current Level',
        name: 'Student Name',
        noResultsMessage: 'No results found for your search or filter.',
        title: 'Students',
        topics: 'Topics',
      },
    },
    jumpBackInSubtitle: 'You did great — now you can try again and get even better!',
    learn1: '{{totalLessonsCount}} quiz to go',
    learnN: '{{totalLessonsCount}} quizzes to go',
    letsPractice: "Let's practice!",
    myDashboard: 'My Dashboard',
    noActivities:
      '"Let’s talk so I will be able to know your needs and suggest practice accordingly! 😊',
    practiceBtn: 'Practice It Now',
    practiceCount: 'You have {{count}} practice suggestion',
    practiceCountPlural: 'You have {{count}} practice suggestions',
    quizStatus: {
      COMPLETED: 'Completed',
      IMPROVEMENT: 'Improvement',
      PRACTICE: 'Practice',
    },
    repeatTopic: 'Repeat Topic',
    report: {
      avgConversationDuration: 'Average Duration',
      avgMistakes: 'Average Corrections',
      cefr: 'CEFR',
      conversation1: '{{numberOfConversations}} Conversation',
      conversationLevel: 'Level',
      conversationSummary: 'Conversation Summary',
      conversationsN: '{{numberOfConversations}} Conversations',
      description: 'Description',
      duration: 'Duration',
      errorsFound: 'Noticed {{errors}} times',
      evaluationSummary: 'Conversation Evaluation',
      topicOfConversation: 'Topic of conversation',
      totalConversations: 'Total Conversations',
      watchHistory: 'Review the conversation',
    },
    score: 'Score',
    seeMyChatsBtn: 'See All >',
    showMoreHistory: '+ Show More',
    sortOptions: {
      createdDateAscending: 'Date, From old to new',
      createdDateDescending: 'Date, From new to old',
      rankAscending: 'Ranking, From low to high',
      rankDescending: 'Ranking, From high to low',
      scoreAscending: 'Score, From low to high',
      scoreDescending: 'Score, From high to low',
      statusAscending: 'Status, From practice to completed',
      statusDescending: 'Status, From completed to practice',
      topicAscending: 'Topic (A-Z)',
      topicDescending: 'Topic (Z-A)',
    },
    statistics: {
      averageConversationTime: '⏱️ Average Conversation Time',
      filter: {
        month: 'Last 30 Days',
        rangeDate: 'Custom Date Picker',
        staticTitle: 'Display Data Of:',
        week: 'Last 7 Days',
      },
      studentsUsingTutor: '💬 Students Using Tutor',
      totalStudents: '👤 Total Students',
    },
    youCanDoIt: '🚀 You did it!',
    youHas1Chat: 'You have 1 conversation',
    youHasNChat: 'You have {{numberOfConversations}} conversations',
    yourChats: 'Your Chats',
  },
  nameAndStatus: 'Name & Status',
  needHelp: 'Need Help?',
  new_password: 'New Password',
  new_password_verification: 'Re-Enter New Password',
  next: 'Next',
  nextPage: 'Next Page',
  nextQuestion: 'Next question',
  nextQuiz: 'Next activity',
  nextWord: 'Next Word',
  niceEffort: 'Nice effort,',
  noClassToImport: 'There is no class to import',
  noClassToImportDescription:
    'You first need to create your classes in your Google Classroom page https://classroom.google.com/, and then you will be able to import your students here.',
  noExtraCoins: 'No Extra Coins',
  noLevelAssignedMessage: 'Please ask your teacher to set your level so you can start.',
  noLevelAssignedTitle: "You don't have a level assigned yet.",
  noLongerAvailable: 'No longer available — deleted in Google Classroom',
  noStudentMistake:
    'In case you do have students in this class, please contact your school admin. ',
  noStudents: 'No students in this class',
  noTrailingSpaces: 'Name can`t have trailing spaces',
  none: 'None',
  notAvailable: 'N/A',
  notFoundError: '404 Error',
  notMadeIt: "It looks like you didn't make it this time, you can",
  notifications: {
    event: {
      accountDeleted: {
        body: 'Your Hello account has been deleted.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your Hello account has been deleted.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your Hello account has been deleted.',
        title: 'Your account has been deleted.',
      },
      adminDealExpired: {
        body: 'Your school’s Hello Britannica subscription has expired. Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        title: 'Your school’s Hello Britannica subscription has expired',
      },
      assignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'You have been assigned to {{className}}.',
        title: "You've been assigned to a class",
      },
      classDeleted: {
        body: '{{className}} has been deleted.',
        title: 'Your class has been deleted',
      },
      classGradeEdited: {
        body: 'The grade for {{className}} has been changed from {{oldGradeStr}} to {{newGradeStr}}.',
        title: 'Your class grade has been updated',
      },
      classNameEdited: {
        body: '{{oldClassName}} has been renamed to {{newClassName}}.',
        title: 'Your class has been renamed',
      },
      classesDeleted: {
        body: '{{numberOfClasses}} classes have been deleted.',
        body_one: '1 class has been deleted.',
        title: 'Your classes have been deleted',
      },
      coTeacherAdded: {
        body: '{{teacherFullName}} was assigned to your class {{className}}.',
        title: 'Co-Teacher was added to your class',
      },
      coTeacherAssignedToNewClass: {
        actionText:
          'Please invite students to join your class or add them yourself through the Hello platform.',
        body: 'You have been assigned to {{className}}.',
        title: "You've been assigned to a class",
      },
      coTeacherRemoved: {
        body: '{{teacherFullName}} was removed from your class {{className}}.',
        title: 'Co-Teacher was removed from your class',
      },
      dealDateExpirationUpdated: {
        body: 'Your school’s Hello Britannica subscription expiration date has been updated to {{dateStr}}.',
        title: 'Expiration date changed for your school’s Hello Britannica subscription',
      },
      interfaceLanguageChanged: {
        body: 'Your interface language has been changed to {{newLanguageStr}}.',
        title: 'Your interface language has been updated',
      },
      levelChanged: {
        body: 'Your English level has been changed from {{oldLevel}} to {{newLevel}}.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity your level has been changed from {{oldLevel}} to {{newLevel}}.<br/>You will now be redirected to the next level.',
        title: 'Your level has been updated',
      },
      levelTestNotFinished: {
        body: 'Come back and finish a few more questions to begin practicing with Hello Britannica.',
        title: 'Say "Hello" to learning English',
      },
      levelTestNotTaken: {
        body: 'Check your English with a short quiz to unlock activities.',
        title: 'Get started with Hello Britannica',
      },
      licenseLimitReached: {
        actionText:
          'To extend your subscription with additional licenses, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
        body: 'Your school has reached its license limit. No additional students can be registered. Please contact Hello Britannica support to add more licenses.',
        title: 'License limit reached',
      },
      movedToDifferentClass: {
        body: 'You have been moved from {{oldClassName}} to {{newClassName}}.',
        title: "You've been moved to a new class",
      },
      movedToDifferentClassWithLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'You were assigned to a new class',
      },
      movedToDifferentClassWithPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity you were assigned to a new class. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'You were assigned to a new class',
      },
      nameChanged: {
        body: 'Your name has been updated to {{newFullName}}.',
        title: 'Your name has been updated',
      },
      removedFromClass: {
        body: 'You have been removed from {{className}}.',
        title: "You've been removed from a class",
      },
      studentAdvancedToNewLevel: {
        body: '{{studentFullName}} from {{className}} has advanced from {{oldLevel}} to {{newLevel}}.',
        title: 'A student reached a new level',
      },
      studentDealExpired: {
        body: 'Access to Hello Britannica has ended for your school. Please contact your teacher or school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Platform access has ended',
      },
      studentDeleted: {
        body: '{{studentFullName}} has been deleted from {{className}}.',
        title: 'A student has been deleted from your class',
      },
      studentGroupAllowIndividualAdvancement: {
        body: 'You will now advance to the next level.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You will now advance to the next level.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupLevelSet: {
        body: 'Your level was set to {{newLevel}}. Please log in again to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. Your level was set to {{newLevel}}. Please log in again to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentGroupPlacementTestRequired: {
        body: 'You are now required to take the level test. Please log in again and complete it to get started.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity a setting for your class has been changed. You are now required to take the level test. Please log in again and complete it to get started.',
        title: 'A setting for your class has been changed.',
      },
      studentInactivityDigest1m: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past month.',
        body_one: '1 student has not engaged in Hello Britannica in the past month.',
        title: 'Assign your students activities to complete in Hello Britannica',
      },
      studentInactivityDigest2w: {
        body: '{{numberOfStudents}} students have not engaged in Hello Britannica in the past two weeks.',
        body_one: '1 student has not engaged in Hello Britannica in the past two weeks.',
        title: 'Encourage your students to practice English with Hello Britannica',
      },
      studentWeeklyInactivity: {
        body: 'You scored {{lastCompletedActivityScore}} on your last Hello Britannica activity. Can you beat it?',
        body_noScore:
          "You haven't completed any Hello Britannica activity yet. Why won't you try it?",
        title: 'Don’t forget to practice your English today!',
      },
      studentsAssignedToClassByAdmin: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} students have been added to {{className}}.',
        body_one: '1 student has been added to {{className}}.',
        title: 'Students have been added to your class',
      },
      studentsDeleted: {
        body: '{{numberOfStudents}} students have been deleted from {{className}}.',
        body_one: '1 student has been deleted from {{className}}.',
        title: 'Students have been deleted from your class',
      },
      studentsJoinedSinceLastLoginWithOutStudents: {
        body: 'No students have joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedSinceLastLoginWithStudents: {
        body: '{{numberOfStudents}} students have joined your school since your last login.',
        body_one: '1 student has joined your school since your last login.',
        title: 'New students since your last login',
      },
      studentsJoinedViaTeacherInvitation: {
        actionText:
          'Please ensure the new students complete the level test so they can start playing.',
        body: '{{numberOfStudents}} students have joined {{className}}.',
        body_one: '1 student has joined {{className}}.',
        title: 'A student has joined your class',
      },
      studentsLevelChangedByOperator: {
        body: '{{studentFullName}}’s English level has been changed from {{oldLevel}} to {{newLevel}}.',
        title: 'Your student’s level has been changed',
      },
      studentsMovedOutOfTheClass: {
        body: '{{numberOfStudents}} students have been moved from {{oldClassName}} to {{newClassName}}.',
        body_one: '1 student has been moved from {{oldClassName}} to {{newClassName}}.',
        title: 'Students moved out of the class',
      },
      teacherCreatedNewClass: {
        body: '{{className}} has been created.',
        title: 'A new class has been created',
      },
      teacherDealExpired: {
        body: 'Access to Hello Britannica has ended for you and your students. Please contact your school administrator for more information.',
        body_gameSummary:
          'You completed the activity with a score of {{activityScore}} and {{activityStars}} stars.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        body_skippedGameSummary:
          'You skipped this activity.<br/>During the activity access to Hello Britannica has ended for your school.<br/>Please contact your teacher or school administrator for more information.',
        title: 'Hello Britannica access has ended',
      },
      teacherDeletedClassWithOutStudents: {
        body: '{{className}} has been deleted.',
        title: 'A class has been deleted',
      },
      teacherDeletedClassWithStudents: {
        body: '{{className}} has been deleted. {{numberOfStudents}} students also were deleted.',
        body_one: '{{className}} has been deleted. 1 student also was deleted.',
        title: 'A class has been deleted',
      },
      topicCompletedLowScore: {
        body: '{{studentFullName}} completed a topic with scores lower than 70 in skills: {{skillsListStr}}.',
        body_one:
          '{{studentFullName}} completed a topic with a score lower than 70 in {{skillsListStr}}.',
        title: 'Your student may need extra help',
      },
      weeklyClassSummaryWithActivity: {
        body: 'Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level / {{numberOfStudentsCompletedUnit}} students completed a unit / {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted.',
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklyClassSummaryWithOutActivity: {
        body: "Here is your weekly summary of activity in Hello Britannica for {{className}} (week of {{dateStr}}): nothing has changed this week. Encourage your students to practice their English with Hello Britannica regularly and you'll see them completing units in no time!",
        title: 'Weekly Report - Hello Britannica activity summary for {{className}}',
      },
      weeklySchoolSummaryWithActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): {{numberOfStudentsWereAdded}} students were added / {{numberOfStudentsWereDeleted}} students were deleted / {{numberOfTeachersHaveJoined}} teachers have joined / {{numberOfClassesWereCreated}} classes were created / {{numberOfStudentsAdvancedToNewLevel}} students advanced to a new level.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
      weeklySchoolSummaryWithOutActivity: {
        body: 'Here is your weekly summary for {{schoolName}} (week of {{dateStr}}): nothing has changed this week. To get the most out of Hello Britannica, remind teachers to encourage their students to practice their English language skills regularly.',
        title: 'Weekly Report - Hello Britannica activity summary for {{schoolName}}',
      },
    },
    list: {
      allNotificationsMessage: 'No more notifications from the last 30 days.',
      markAllAsReadButton: 'Mark all as read',
      noNotificationsMessage: 'No new notifications.',
      sendDataWithOperator: '{{createdAtStr}} | by {{operatorFirstName}} {{operatorLastName}}',
      sendDataWithoutOperator: '{{createdAtStr}}',
      title: 'Notifications',
    },
    popup: {
      okButton: 'OK',
    },
  },
  ofThisSite: 'of this site.',
  offlineNotification: {
    button: 'OK',
    description: 'When you will be online again, you will be able to continue using the platform.',
    title: 'You are currently offline.',
  },
  ok: 'OK',
  okLetsGo: "Ok, Let's go!",
  oneMoreMistake: 'One more mistake will end the game,',
  onlyNumbersAllowed: 'Only numbers are allowed',
  oops: 'Oops',
  oopsDots: 'Oops...',
  orClickHereToSendAgain: 'Or <0>click here</0> to send the code again.',
  orLoginWithGoogle: 'Or continue with Google Classroom',
  organizationNameTooLong: 'School name can be up to 70 characters.',
  outOf: 'out of',
  overallProgress: 'Overall Progress',
  pageNotFound: 'Page Not Found',
  partialImportError:
    'Some classes could not be imported because they have already been imported by another teacher. The remaining classes were imported successfully.',
  passRate: 'Pass Rate',
  password: 'Password',
  passwordMinimumLength: '8 characters minimum length',
  password_changed_successfully: 'Password changed successfully',
  passwordsDontMatch: "Passwords don't match",
  pause_game: 'Pause Game',
  paussed: 'Paused',
  phone: 'Phone',
  pictureOfTheDay: 'Picture Of The Day',
  play_sound: 'Play Sound',
  pleaseChooseYourOwnPassword: 'Please choose your own password',
  pleaseEnterTheFollowing: 'Please enter the following information to begin your',
  pleaseEnterYourDetails: 'Please enter your details',
  pleaseSelectYourAccount: 'Please select your account or log in from another one',
  pleaseTakeAMoment: 'Please take a moment to register your school.',
  pleaseTryAgain: 'Please try again.',
  practice: 'Practice',
  practiceAgain: 'Practice again',
  practiceProperPronunciation:
    'Practice saying new words or sentences. Click on the blue microphone and say them. Then, click on the blue microphone again when you are done speaking. Speak slowly.',
  practiceYourVocabulary: 'Practice your vocabulary',
  preferences: 'Preferences',
  premiumSection: {
    description:
      'Lorem ipsum dolor sit amet lorem ipsum dolor sit amet lorem ipsum dolor sit ametLorem ipsum dolor sit amet',
    title: 'Try lorem ipsum for free',
    unlock: 'Unlock Premium',
  },
  preparationAudioToImage:
    'This is a fun listening activity.  Click on the listening button and listen to the audio.  Then, match it with the correct picture.',
  preparationAudioToImageMobile:
    'This is a fun listening activity.  Click on the listening button and listen to the audio.  Then, match it with the correct picture.',
  preparationClosedSpelling:
    'This is a fun way to practice spelling. Look at the picture. Use the letters to spell the words. ',
  preparationClosedSpellingMobile:
    'This is a fun way to practice spelling. Look at the picture. Use the letters to spell the words. ',
  preparationDescriptionFirstPart:
    'This is a fun listening activity.  Click on the listening button and listen to the audio.  Then, match it with the correct picture.',
  preparationDescriptionFirstPartMobile:
    'This is a fun listening activity.  Click on the listening button and listen to the audio.  Then, match it with the correct picture.',
  preparationDescriptionSecondtPart: "It's like a puzzle that helps you learn English!",
  preparationGrammar:
    'Read the questions and choose the correct option.  Look for the grammar tip!  Are you ready?  Let’s practice grammar! ',
  preparationGrammarMobile:
    'Read the questions and choose the correct option.  Look for the grammar tip!  Are you ready?  Let’s practice grammar! ',
  preparationImageToText:
    'Learn English and have fun! Look at the picture and match it with the correct option.',
  preparationImageToTextMobile:
    'Learn English and have fun! Look at the picture and match it with the correct option.',
  preparationListen:
    'Have fun with listening!  Click on the listening button and listen.  Then, choose the correct answer.',
  preparationListenMobile:
    'Have fun with listening!  Click on the listening button and listen.  Then, choose the correct answer.',
  preparationMemory: 'Have fun and practice English!  Match the words with the pictures. ',
  preparationMemoryMobile: 'Have fun and practice English!  Match the words with the pictures. ',
  preparationNaturalConversation:
    'Practice speaking in English!  Click on the listening button and listen. Choose the right answer. Then, click on the blue microphone and say it out loud.  Click on the blue microphone again when you are done speaking. ',
  preparationNaturalConversationMobile:
    'Practice speaking in English!  Click on the listening button and listen. Choose the right answer. Then, click on the blue microphone and say it out loud.  Click on the blue microphone again when you are done speaking. ',
  preparationOpenWriting:
    'Practice your writing in a fun way!  Read the question and look at the image. Then, write the answer. ',
  preparationOpenWritingMobile:
    'Practice your writing in a fun way!  Read the question and look at the image. Then, write the answer. ',
  preparationRead: 'Read and answer the questions.  Let’s go!',
  preparationReadMobile: 'Read and answer the questions.  Let’s go!',
  preparationSecondtPartGrammar: 'Don’t worry, you’ll get tips along the way to help.',
  preparationSecondtPartImageToText: 'Good luck!',
  preparationSecondtPartSpeak: 'Good luck!',
  preparationSecondtPartTextToImage: 'Good luck!',
  preparationSecondtPartVocabulary:
    "Let's see how well you know your vocabulary. <b>Good luck!</b>",
  preparationSpeaking:
    'Practice saying new words or sentences. Click on the blue microphone and say them. Then, click on the blue microphone again when you are done speaking. Speak slowly.',
  preparationSpeakingMobile:
    'Practice saying new words or sentences. Click on the blue microphone and say them. Then, click on the blue microphone again when you are done speaking. Speak slowly.',
  preparationTextToImage:
    'This is a fun way to practice English!  Read and choose the correct picture. ',
  preparationTextToImageMobile:
    'This is a fun way to practice English!  Read and choose the correct picture. ',
  preparationTextToText:
    'Have fun with new words, grammar, and reading!  Read the sentences or the questions and choose the correct answer. ',
  preparationTextToTextMobile:
    'Enhance your reading comprehension, vocabulary, and grammar by choosing the correct answer that best completes the following sentences.',
  preparationVocabulary:
    'Practice new words! Follow the instructions and choose the correct option.',
  preparationVocabularyMobile:
    'Practice new words! Follow the instructions and choose the correct option.',
  privateTutor: 'Private Tutor',
  processing: 'Processing',
  profile: 'Profile',
  progress: 'Progress',
  provideClassCode: 'Please provide your class code',
  question: 'Question',
  questions: 'Questions',
  questionsAndConcerns: 'questions and concerns.',
  questionsLeft: 'number of questions left',
  quiz: 'Activity',
  quizzes: 'Quizzes',
  quizzesCompleted: 'Games completed',
  ran_out_of_time: 'It looks like you ran out of time again. This question will be marked as',
  rateYourself: 'Rate Yourself',
  readMore: 'Read more',
  readWithImageStartQuizInstructions: 'Read the text and answer the questions that follow.',
  read_tip: 'Read Tip',
  readyToChooseYourAvatar: 'Ready to choose your avatar?',
  refresh: 'Refresh',
  registrationDealExpiredMessageDescription:
    'Please contact your teacher or school administrator for guidance.',
  registrationDealExpiredMessageDescriptionAdmin:
    'Access through the website and our apps has been disabled for all users in your school. To renew your subscription and reinstate access, contact Support at <a href="mailto:info@eb.com">info@eb.com</a>.',
  registrationDealExpiredMessageDescriptionTeacher:
    'Please contact your school administrator for guidance.',
  registrationDealExpiredMessageTitle: 'This link has already expired. 😕',
  registrationDealLimitReachedMessageDescription:
    'Please contact your teacher or school administrator for guidance.',
  registrationDealLimitReachedMessageTitle: 'This school has reached its user limit. 😕',
  reports: {
    activitiesCompletedInLevel: 'Activities Completed in Level {0}',
    allLevelsAvgTime: '📊 Average Time All Levels',
    attemptsAndHints: 'Attempts & Hints',
    averagePerSkill: 'Average per skill',
    avgActivitiesCompleted: 'Average Activities Completed',
    avgAttempts: 'Attempts',
    avgAttemptsPerActivity: 'Attempts',
    avgFailureRate: 'Average Failure Rate',
    avgHintsPerActivity: 'Avg. hints per activity',
    avgPassRate: 'Average Pass Rate',
    avgPerWeek: 'Avg. per week',
    avgSkillScores: 'Skill Scores',
    avgStreakLength: 'Streak Length',
    avgStreakPerWeek: 'Avg. streak per week',
    avgStudentProgress: 'Student Progress on Current Level',
    avgTimeSpent: 'Avg. Time Spent',
    continuousEngagement: 'Average days/week of continuous engagement',
    daysPerWeek: '{0} Days Per Week',
    engagedStudentsWord_one: 'engaged student',
    engagedStudentsWord_other: 'engaged students',
    engagement: 'Engagement',
    failureRate: 'Fail Rate',
    inCurrentLevel: 'In Current Level',
    longestStreak: 'Longest streak',
    onActivities: 'Average on activities by level',
    overallProgressInLevel: 'Overall Progress in Level {0}',
    passRate: 'Pass Rate',
    perActivity: 'Average per activity',
    perLevel: 'Average per level',
    previous7Days: 'Previous 7 days',
    progress: 'Progress',
    remark: 'This data represents <b>{0}</b> {1} out of <b>{2}</b> total {3} in the class.',
    skippedActivitiesComment: '* Skipped activities are included in total activities',
    streakLast7Days: 'Streak over last 7 days',
    streakLength: 'Streak Length',
    studentsOnlyWord_one: 'student',
    studentsOnlyWord_other: 'students',
    timeSpentOnActivites: 'Time Spent on Activites',
    total: 'Total',
    totalHintsUsed: 'Total hints used',
    totalInPrev7Days: 'Total in prev. 7 days',
    totalStudents: 'Total Students',
  },
  requirements: 'Requirements',
  resendVerificationCode: 'Didn’t receive it? Send code again',
  resetPassword: 'Reset Password',
  resetPasswordRequest: 'Reset password request has been sent to your teacher!',
  resolved: 'Ok, changed it!',
  results: 'Results',
  resume: 'Resume',
  review: 'Review',
  reward: 'Reward',
  saturdayShort: 'Sat',
  save: 'Save',
  schoolName: 'School Name',
  score: 'Score',
  scrollToTop: 'Scroll to top',
  searchClasses: 'Search and/or select an option',
  searchForStudent: 'Search for student',
  searchStatus: 'Search status',
  selectAll: 'Select All',
  selfPracticeStreak: 'Self Practice Streak',
  send: 'Send',
  sendNow: 'Send now',
  settings: {
    about_me: 'About Me',
    add_students: {
      add_student: 'Add New Student',
      add_students_manually: 'Add Manually',
      button_next: 'Next',
      classCreatedDescriptionNoLevelTest:
        'Your students have been emailed instructions for resetting their password. Once your students log in, they will be placed at the default level and may begin their learning journey.',
      click_to_browse: 'click to browse',
      create_students: 'The following students will receive an invitation email',
      download: 'Download',
      download_sample: 'a sample Excel (xlsx) file',
      drag_here: 'Drag a file here or ',
      email_will_be_send: 'An email with a temporary password will be sent to the student',
      enroll_students: 'Enroll students',
      enrollment_unsuccessful: '⚠️ Enrollment Unsuccessful!',
      enrollment_unsuccessful_description:
        'The following students could not enroll because their email has already been used:',
      errors: {
        bad_formatting:
          'Your file is not formatted correctly. <br/> Please check your data and make corrections as needed',
        email_in_use: 'This email address is already registered',
        email_incorrect: 'Please enter a valid email address.',
        file_empty: 'The file you are trying to upload is empty',
        file_too_large: 'The file is too large. Maximum size allowed is 256KB.',
        first_name_incorrect: 'First name contains invalid characters or is too long.',
        first_name_missing: 'First name is required.',
        first_name_too_long: 'First name can be up to 30 characters.',
        last_name_incorrect: 'Last name contains invalid characters or is too long.',
        last_name_missing: 'Last name is required.',
        last_name_too_long: 'Last name can be up to 40 characters.',
        limit_reached:
          'The maximum number of student per class is 50. <br/> Please remove and upload a new file.',
        limit_reached_description: 'Your class contains the maximum number of students allowed.',
        limit_reached_title: 'This class is already full.',
        max_number_of_students:
          'The maximum number of student per class is 50. <br/> Please remove and upload a new file.',
        students_not_registered: 'Some students were not registered',
        username_invalid: 'This username is already taken',
        username_missing: 'Username is required.',
        wrong_format:
          'The file format is incorrect. <br/> Please ensure you are uploading an Excel (xlsx) file.',
      },
      invite_students: 'Invite Students',
      not_enough_licenses_blocked_one:
        "Your request to add 1 student has been blocked because your school's license limit cannot accommodate them.",
      not_enough_licenses_blocked_other:
        "Your request to add {{requested}} students has been blocked because your school's license limit cannot accommodate them all.",
      not_enough_licenses_remaining_one:
        'There is only 1 seat remaining. You may invite fewer students to fill the remaining seat or contact us for assistance.',
      not_enough_licenses_remaining_other:
        'There are only {{available}} seats remaining. You may invite fewer students to fill the remaining seats or contact us for assistance.',
      not_enough_licenses_teacher_blocked_one:
        "Your request to add 1 student has been blocked because your school's user limit cannot accommodate them.",
      not_enough_licenses_teacher_blocked_other:
        "Your request to add {{requested}} students has been blocked because your school's user limit cannot accommodate them all.",
      not_enough_licenses_teacher_remaining_one:
        'There is only 1 seat remaining. You may invite fewer students to fill the remaining seat or contact your school administrator for guidance.',
      not_enough_licenses_teacher_remaining_other:
        'There are only {{available}} seats remaining. You may invite fewer students to fill the remaining seats or contact your school administrator for guidance.',
      partial_success: '⚠️ Partial Success',
      partial_success_description:
        '{{addedStudents}} out of {{totalStudents}} students have successfully enrolled in this class.<br/>They have been sent an email with their temporary password.',
      upload_attention_text:
        '⚠️ Your class contains {{curent}}/{{limit}} students.<br/>You may enroll {{certified}} more students.',
      upload_attention_text_new_class: '⚠️ Max. {{limit}} students per class',
      upload_file: 'Upload your students excel file',
      upload_successful: 'Your file has been uploaded successfully.',
    },
    class: 'My Class',
    current_level: 'Current Level',
    delete_class: {
      areYouSure: 'Are you sure?',
      cancel: 'Cancel',
      classNotEmpty: "You can't delete a class that contains students.",
      classNotEmptyDescription:
        "If you would like to delete this class, you must first delete those students. You can do this by opening the student's profile and clicking the Edit icon.",
      delete: 'Delete',
      deletingFailed: 'We had a technical problem.',
      deletingFailedDescription:
        'Our servers are not responding. Please try again. If the problem persists, please contact us at <a href="mailto:{{email}}">{{email}}</a>',
      description: 'You’re about to delete your class. This cannot be undone.',
      tryAgain: 'Try again',
    },
    delete_student: {
      areYouSure: 'Are you sure?',
      cancel: 'Cancel',
      choose: 'Choose',
      delete: 'Delete',
      deleteStudent: 'Delete student',
      deletingFailed: 'Deleting failed.',
      deletingFailedDescription: '',
      description:
        'Deleting this student will permanently remove them from the platform. This student will no longer be able to log in and all progress data will be lost. Please provide a reason:',
      reason: 'Reason',
      reasons: {
        aClericalError: 'A clerical error',
        other: 'Other',
        requestedToBeRemoved: 'The student or parent requested to be removed',
      },
      why: 'Why?',
    },
    grade: 'Grade',
    home: 'Home',
    interface_language: 'Interface language',
    language: 'Language',
    logout: 'Sign Out',
    my_classes: 'My Classes',
    my_games: 'My Games',
    my_students: 'My Students',
    my_tutor: 'My Private Tutor',
    native_language: 'My Home Language',
    privacy_policy: 'Privacy Policy',
    profile: 'Profile',
    school_id: 'My School',
    security: 'Security',
    title: 'Settings',
    username: 'My Name',
  },
  setupYourClass:
    'Set up your class, then you will receive class code to send to your students. They will do a quick registration process, and then be able to join to your class!',
  signIn: 'Sign in',
  signYouIn: 'Signing you in ...',
  sign_out: 'Sign Out',
  sixDigits: '6 digits',
  sixDigitsAtLeast: 'The code must be 6 digits at least',
  skills: {
    grammar: 'Grammar',
    listen: 'Listening',
    read: 'Reading',
    speak: 'Speaking',
    spelling: 'Spelling',
    vocabulary: 'Vocabulary',
  },
  skip: 'Skip',
  skipAllRecording: 'Skip all recordings',
  skipThisQuestion: 'skip this question',
  skipped: 'Skipped',
  skippedPopUpSummary: {
    speak: {
      bannerTitle: 'Skipped',
      description: "This activity is skipped and won't be graded. You can return to it later.",
      title: 'You chose to skip this activity',
    },
  },
  somewhatAgree: 'Somewhat Agree',
  sortBy: 'Sort by:',
  soundAnalyzingSentences: {
    '0': 'Please wait while we are analyzing your answer',
    '1': 'Speak activities can help you learn English better',
    '2': 'Almost there..',
    numberOfSentences: '3',
  },
  speak_tip: 'Speak Tip',
  spelling_tip: 'Spelling Tip',
  stars: 'Stars',
  start: 'Start',
  startActivity: 'Start Activity',
  startLevelTest: 'Start Level Test',
  startNewConversation: 'Start New Conversation',
  startQuiz: 'Start game',
  startSkippedActivities: 'Start Skipped Activities',
  startingLevel: 'Starting Level',
  startingReward: 'Starting reward',
  state: 'State',
  status: 'Status',
  studentInstructions: 'Student Instructions',
  studentMetricsDashboard: {
    charts: {
      avgScores: {
        subTitle: 'Average student score by skill',
        title: 'Student Scores',
      },
      avgStudentGrowth: {
        subTitle: 'Average cumulative progress through levels by month',
        title: 'Total Level Progress',
        tooltipTitle: 'Total Level Progress',
      },
      avgStudentProgressAtCurrentLevel: {
        levelInfo: 'Level {{level}}\n({{studentCount}} Stu.)',
        subTitle: 'Average progress by students at each level',
        title: 'Student Progress on Current Level',
      },
      kpis: {
        averageTimeSpent: {
          label: '📊 Average Time Spent',
          tooltip: 'Average of all time spent by students actively playing.',
        },
        failureRate: {
          label: '🙁 Fail Rate',
          tooltip: 'The percentage of activities that were attempted and failed',
        },
        passRate: {
          label: '✅ Pass Rate',
          tooltip: 'The percentage of activities that were successfully passed',
        },
        studentsThatPassedLevel: {
          label: '🚀 Students who passed a level',
          tooltip: 'Number of students who passed at least one level.',
        },
        totalActivitiesPassed: {
          label: '🏆 Total Activities Passed',
          tooltip: 'The number of unique activities that were passed with a score of 60 or higher.',
        },
        totalTimeSpent: {
          label: '⏰ Total Time Spent',
          tooltip: 'Sum of all time spent by students actively playing.',
        },
      },
      studentLevelProgression: {
        levelInfo: 'Level {{level}}\n({{studentCount}} Stu.)',
        subTitle: 'Number of students at each level, shown by starting level',
        title: 'Student Level Progression',
        tools: {
          studentStartedAtL1: 'Started at L1',
          studentStartedAtL2: 'Started at L2',
          studentStartedAtL3: 'Started at L3',
          studentStartedAtL4: 'Started at L4',
          studentStartedAtL5: 'Started at L5',
          studentStartedAtL6: 'Started at L6',
        },
      },
      studentsAcrossSkills: {
        subTitle: 'Percentage of students passing by skill',
        title: 'Student Success',
        tools: {
          failure: 'Fail (Under 60)',
          pass: 'Pass',
        },
      },
    },
    drillDown: {
      skills: {
        columns: {
          class: 'Class',
          classNameAndGrade: 'Class & Grade',
          currentLevel: 'Current Level',
          grade: 'Grade',
          name: 'Student Full Name',
          nameAndTeacher: 'Name & teacher',
          skillGrammar: 'Grammar',
          skillListening: 'Listening',
          skillPronunciation: 'Avg. Pronunciation',
          skillReading: 'Reading',
          skillSpeaking: 'Speaking',
          skillSpelling: 'Spelling',
          skillVocabulary: 'Vocabulary',
          teacherNames: 'Teacher Name(s)',
        },
        loadingData: 'Loading skills data...',
        title: {
          AvgScores: 'Student Scores',
          StudentsAcrossSkills: 'Student Success',
        },
        totalStudents: 'Engaged Students: {{totalStudents}}',
      },
      students: {
        allLevelsHint: 'Data reflects the student’s work in all levels.',
        columns: {
          class: 'Class',
          completedActivities: 'Comp. activities',
          currentLevel: 'Current Level',
          firstLogin: 'First Login',
          grade: 'Grade',
          lastLogin: 'Last Login',
          name: 'Student Full Name',
          nameAndTeacher: 'Name & teacher',
          progress: 'Progress',
          score: 'Score',
          startingLevel: 'Starting Level',
          teacherNames: 'Teacher Name(s)',
          timeSpent: 'Time Spent',
          totalActivities: 'Total Activities',
        },
        levelHint: 'Data reflects the student’s work in all levels.',
        loadingData: 'Loading level data...',
        notAvailable: 'N/A',
        subTitle: '*The starting level was changed.',
        title: {
          AvgStudentGrowth: 'Total Level Progress',
          AvgStudentProgressAtCurrentLevel: 'Student Progress on Current Level',
          StudentLevelProgression: 'Student Level Progression',
        },
        totalStudents: 'Engaged Students: {{totalStudents}}',
      },
    },
    emptyState: {
      filter: {
        description: 'Students have started no activities during the selected time period.',
        title: 'No data for selected period',
      },
      global: {
        description: 'When students start their activities, their progress will appear here.',
        title: 'No activity yet',
      },
    },
    exportData: {
      button: 'Export Data',
      fileName: 'Students Metrics Dashboard',
      sheet: {
        levels: 'Levels',
        skills: 'Skills',
      },
    },
    filters: {
      completedActivities: 'Completed Activities',
      currentLevel: 'Current Level',
      currentLevelSearchPlaceholder: 'Search level',
      firstLogin: 'First Login',
      grade: 'Grade',
      gradeSearchPlaceholder: 'Search grade',
      group: 'Class Name',
      groupSearchPlaceholder: 'Search class',
      lastLogin: 'Last Login',
      startingLevel: 'Starting Level',
      startingLevelSearchPlaceholder: 'Search level',
      studentName: 'Student Name',
      studentNameSearchPlaceholder: 'Search student',
      teacher: 'Teacher Name',
      teacherSearchPlaceholder: 'Search teacher',
      timeRange: 'Time range',
      timeSpent: 'Time Spent',
    },
    loadingMetrics: 'Loading metrics...',
    pageTabs: {
      data: 'Data',
      metrics: 'Metrics',
    },
    totalStudents: 'Engaged Students: {{totalStudents}}',
  },
  studentName: 'Student Name',
  studentProfile: 'Student Profile',
  studentReport: 'Student Report',
  students: 'Students',
  studentsContent: {
    levelHint: 'Data reflects students’ work in their current level.',
  },
  subject: 'Subject',
  submit: 'Submit',
  suggested_languages: 'Suggested Languages',
  sundayShort: 'Sun',
  sync: 'Sync',
  syncDataDescription:
    'This action will synchronize the data difference between Hello and Google Classroom, and will include the latest updates that have been made.',
  syncYourData: 'Sync your data',
  synonyms: 'Synonyms',
  tapToSpeak: 'Click to speak',
  teacherInstructions: 'Teacher Instructions',
  teacherLetsBeginn: "Let's Begin!",
  teacherMobile: {
    classesMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    studentsMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
    tutorMessage:
      'To watch your full classes reports and dashboards, please use the desktop version',
  },
  teacherName: 'Teacher Name',
  teachers: 'Teachers',
  teachersThatHaveRegistered: 'Teachers that have registered',
  temporaryPassword: 'The Temporary Password:',
  termsAndConditions: 'Terms and Conditions',
  testYourEnglish: 'Test your English level',
  thankYou: 'Thank you!',
  thanksForSubmission: 'Thank you for your submission!',
  thats_the_way: 'That’s the way!',
  theAnswerIsIncorrectWhatWeHeardWas: 'The answer is incorrect, what we heard was:',
  thisStudentIsInactive:
    'This student is inactive. They have been invited to the class, but have not yet changed their temporary password and have not yet started the initial level placement test.',
  thisStudentIsLevelTestIncomplete:
    "This student has not yet completed the initial level placement test. Once they have done so, you'll be able to see their progress.",
  thisTopicWillHelpMe: 'This topic will help me',
  thursdayShort: 'Thurs',
  timeIsUp: 'Time is up!',
  timeSpent: 'Time Spent',
  tip: 'Tip!',
  tipsAndTricks: 'Tips and Tricks',
  to: 'To',
  toImproveYourVocabulary: 'To improve your vocabulary,',
  toNextQuestion: 'to the next question',
  toggle: 'Toggle',
  topicProgress: 'Topic progress',
  topics: 'Topics',
  totalActivities: 'Total Activities',
  totalCoins: 'Total Coins',
  totalHintsUsed: 'Total Hints Used',
  totalProgressWithinLevel: 'Total Progress within the level',
  totalQuizzes: 'Total games',
  totalTimeSpent: 'Total Time Spent',
  totalTimeSpentTooltip: 'Sum of all time spent by students actively playing.',
  totalTimeSpent_mobile: 'Total Time Spent',
  tries: 'tries',
  tryAgain: 'Try again',
  tryAgainBtn: 'Try again one more time',
  tryAgainLater: 'Try again later!',
  tryAgainOneMore: 'try again 1 more time or move on',
  tryAgainOrKeepGoing: 'Try again or keep going',
  tryBetter: 'Try better next time',
  tryToGetAllStars: 'This time, try to get all three stars!',
  tuesdayShort: 'Tues',
  tutorBack: '< Back',
  tutorCorrectAnswerIsShort: 'The correct answer is <strong>{{answer}}</strong>',
  tutorEndActivityBtn: 'End Activity',
  tutorEndConversationBtn: 'End Conversation',
  tutorNewConversation:
    '👋🏻 Hey {{name}}!\nYou\'re building <br class="desktop-br">stronger <span style="color: #05abf4" >grammar</span>\nand <span style="color: #ff9f4c">expression</span> skills!',
  tutorRouterPrompt: {
    activity: {
      cancelBtn: 'Let’s Keep Practicing',
      confirmBtn: 'End Activity',
      description: 'If you end it now, your advancement will not be saved.',
      title: 'End the activity?',
    },
    cancelBtn: 'Let’s Keep Talking',
    confirmBtn: 'End Conversation',
    description: 'If you end it now, this conversation will not be saved.',
    fromCanDoBeforeStarted: {
      cancelBtn: 'Continue with Tutor',
      confirmBtn: 'I’m sure',
      title: 'Are you sure you don’t want to review {{topicName}}?',
    },
    title: 'End the conversation?',
  },
  uncorrectPronounce: 'Try again or skip to the next question.',
  understandingYourEnglishLevel: 'We are starting to understand your English level.',
  unfortunately: "Unfortunately, you didn't pass, so you won't receive any coins for this game.",
  university: 'University',
  update: 'Update',
  uploadCsvErrorModalDescription:
    'You may have some internet related issues.<br />Please try again.',
  uploadCsvErrorModalTitle: 'Upload failed',
  useTheCoins: "Use the coins you've earned to get hints",
  userDataSuccessfullyUpdated:
    'The details have been successfully updated. Please ask student to refresh the page to see the change',
  userStreak: {
    subTitle: 'Practice every day to become a MASTER',
    title: 'Keep the streak!',
  },
  username: 'Username',
  usernameAlreadyExists: 'This username is already taken',
  usernameTooLong: 'Username can be up to 20 characters.',
  usingYourMicrophone:
    'Using your microphone, speak slowly and clearly and make sure there is no background noise.',
  validation: {
    code_required: 'Code is required',
    confirm_password_required: 'Confirm Password is required',
    email_required: 'Email is required',
    password_required: 'Password is required',
    username_or_email_required: 'Username or email is required',
  },
  validationCodeInvalid: 'Validation code invalid',
  verificationCode: 'Verification Code',
  verificationCodeResentCheckEmail:
    'A new verification code was sent to your email. Enter the latest code below.',
  verificationCodeSent: 'A verification code has been sent to',
  viewAnswerChoices: 'View answer choices',
  vocabulary_tip: 'Vocabulary Tip',
  waitingForStudentsDescription:
    'You will be able to see them right after they onboard the platform!',
  waitingForStudentsToJoin: 'Waiting for your students to join!',
  warningTemporaryPassword: 'Please note that temporary password will be valid for 7 days!',
  weAreAnalyzing: 'We are analyzing your writing. Just a few seconds...',
  weCouldNotProduce: 'We could not produce the report at the moment.',
  weStillDontHaveAll:
    "We still don't have all the necessary information, or there is a temporary glitch.",
  we_want_to_know: 'We want to know your level',
  wednesdayShort: 'Wed',
  welcome: 'Welcome',
  welcomeConfetti: 'Welcome',
  welcomeTo: 'Welcome to',
  wellDone: 'Well Done',
  wordCount: 'Word count: {{wordCount}}',
  words: 'Words',
  wordsList: 'Words list',
  wow: 'WOW',
  wow_score_all_stars: 'WOW, you got a score of <b>{{score}}</b> and got all the stars.',
  writeClassNameHere: 'Write class name here',
  writeHere: 'Write Here',
  writeOrSay: 'Write or say your response here...',
  wrongAnswer: 'Wrong answer!',
  yes: 'Yes',
  yesDelete: 'Yes, Delete',
  youAlmostThere: "You're almost there...",
  youAreDoingGreatLetsKeepGoing: 'You’re doing great!<br/>Let’s keep going.',
  youAreOnYourWay: "You're on your way!",
  youCanCreateMore: 'You can create more than one class',
  youCanPractice: 'you can practice words by game or by using flash cards and a list.',
  youHaveCompleted: 'You’ve completed the topic!',
  youMayNowShare: 'You may now share this link with your ',
  youPassedTheQuiz: 'You passed the activity with a score of <b>{{score}}</b>! Great job!',
  youPracticed: "You've practiced. You've studied.",
  youWillLose: 'You will lose',
  you_did_it: 'You Did It!',
  you_got_a_score_try_again:
    'You got a score of <b>{{score}}</b> this time. Try again later to earn more stars.',
  you_got_no_extra_stars: 'You got <b>{{score}}</b> again.',
  your: 'Your',
  yourClasses: 'Сlasses',
  yourMessageHasBeenSentSuccessfully:
    'Your message has been sent successfully. Thank you for taking the time to provide us with valuable feedback!',
  yourMessageHere: 'Your message here',
  yourPasswordHere: 'Your password here',
  yourPhoneHere: 'Your Phone here',
  yourSchoolHasBeenCreated: 'Your school has been created successfully',
  yourStreak: 'Your Streak',
  yourStudentQuiz:
    'This is the quiz that your students will take when they enter the app for the first time. Go ahead and try it now, or you can try it later.',
  yourStudentsHaveNotJoined: 'No Active Students Yet',
  yourSubjectHere: 'Your subject here',
};
